(function () {
  const TOKEN_KEY = 'cavernCollectionSessionToken';
  const EMAIL_KEY = 'cavernCollectionEmail';
  const CATALOG_FILTER_KEY = 'cavernCatalogFilterSettings';
  const CONSOLE_VARIATIONS_SEARCH_INDEX_URL = 'https://consolevariations.com/media/search-index.json';
  const THEME_ASSET_BASE_URL = (() => {
    try {
      const source = document.currentScript?.src || '';
      return source ? new URL('.', source).toString() : '';
    } catch (_) {
      return '';
    }
  })();
  const TABS = ['collection', 'add', 'wishlist', 'sell', 'settings'];
  const DEFAULT_CATALOG_FILTER_SETTINGS = {
    includeImports: false,
    includeComputers: false,
    includeMagazines: true,
  };
  const FALLBACK_CATALOG_SYSTEMS = [
    '3DO',
    'Action Max',
    'Amiga',
    'Amiga CD32',
    'Amiibo',
    'Amiibo Cards',
    'Atari 2600',
    'Atari 5200',
    'Atari 7800',
    'Atari Lynx',
    'Colecovision',
    'Commodore 64',
    'Disney Infinity',
    'Famicom',
    'Famicom Disk System',
    'Game & Watch',
    'GameBoy',
    'GameBoy Advance',
    'GameBoy Color',
    'Gamecube',
    'Intellivision',
    'Jaguar',
    'Jaguar CD',
    'NES',
    'Nintendo 3DS',
    'Nintendo 64',
    'Nintendo DS',
    'Nintendo Switch',
    'Nintendo Switch 2',
    'PC Engine',
    'PC Engine CD',
    'Playstation',
    'Playstation 2',
    'Playstation 3',
    'Playstation 4',
    'Playstation 5',
    'Playstation Vita',
    'PSP',
    'Sega 32X',
    'Sega CD',
    'Sega Dreamcast',
    'Sega Game Gear',
    'Sega Genesis',
    'Sega Master System',
    'Sega Saturn',
    'Skylanders',
    'Super Nintendo',
    'Super Famicom',
    'Virtual Boy',
    'Wii',
    'Wii U',
    'Xbox',
    'Xbox 360',
    'Xbox One',
    'Xbox Series X'
  ];
  const IMPORT_CATALOG_SYSTEMS = new Set([
    'famicom',
    'famicom disk system',
    'pc engine',
    'pc engine cd',
    'super famicom',
  ]);
  const COMPUTER_CATALOG_SYSTEMS = new Set([
    'amiga',
    'amiga cd32',
    'amstrad cpc',
    'apple ii',
    'atari 400',
    'atari st',
    'atari xe',
    'commodore 16',
    'commodore 64',
    'commodore 128',
    'fm towns marty',
    'msx',
    'msx2',
    'jp msx',
    'jp msx2',
  ]);
  const MAGAZINE_CATALOG_SYSTEMS = new Set([
    'club nintendo magazine',
    'dreamcast magazine',
    'electronic gaming monthly',
    'egm',
    'game informer',
    'gamepro',
    'nintendo power',
    'nintendo power magazine',
    'official dreamcast magazine',
    'official nintendo magazine',
    'official playstation magazine',
    'official xbox magazine',
    'tips and tricks',
  ]);
  const ADD_SECTIONS = [
    {
      id: 'nintendo',
      label: 'Nintendo',
      description: 'NES, SNES, N64, GameCube, Wii, Switch, Game Boy, DS, 3DS',
      systems: [
        'NES',
        'Famicom',
        'Famicom Disk System',
        'Super Nintendo',
        'Super Famicom',
        'Nintendo 64',
        'Gamecube',
        'Wii',
        'Wii U',
        'Nintendo Switch',
        'Nintendo Switch 2',
        'GameBoy',
        'GameBoy Color',
        'GameBoy Advance',
        'Nintendo DS',
        'Nintendo 3DS',
        'Virtual Boy',
        'Game & Watch',
      ],
    },
    {
      id: 'playstation',
      label: 'PlayStation',
      description: 'PS1, PS2, PS3, PS4, PS5, PSP, Vita',
      systems: ['Playstation', 'Playstation 2', 'Playstation 3', 'Playstation 4', 'Playstation 5', 'PSP', 'Playstation Vita'],
    },
    {
      id: 'xbox',
      label: 'Xbox',
      description: 'Xbox, Xbox 360, Xbox One, Xbox Series X|S',
      systems: ['Xbox', 'Xbox 360', 'Xbox One', 'Xbox Series X'],
    },
    {
      id: 'sega',
      label: 'Sega',
      description: 'Master System, Genesis, Sega CD, 32X, Saturn, Dreamcast, Game Gear',
      systems: ['Sega Master System', 'Sega Genesis', 'Sega CD', 'Sega 32X', 'Sega Saturn', 'Sega Dreamcast', 'Sega Game Gear'],
    },
    {
      id: 'figures',
      label: 'Figures',
      description: 'Amiibo, Skylanders, Disney Infinity',
      systems: ['Amiibo', 'Amiibo Cards', 'Skylanders', 'Disney Infinity'],
    },
    {
      id: 'magazines',
      label: 'Magazines',
      description: 'Nintendo Power, EGM, GamePro, Game Informer, official magazines',
      systems: [
        'Nintendo Power',
        'Electronic Gaming Monthly',
        'EGM',
        'GamePro',
        'Game Informer',
        'Official Dreamcast Magazine',
        'Official Nintendo Magazine',
        'Official PlayStation Magazine',
        'Official Xbox Magazine',
        'Tips and Tricks',
      ],
    },
  ];
  const CONSOLE_FAMILIES = [
    {
      id: 'nintendo',
      label: 'Nintendo consoles',
      systems: ADD_SECTIONS.find((section) => section.id === 'nintendo').systems,
    },
    {
      id: 'playstation',
      label: 'PlayStation consoles',
      systems: ADD_SECTIONS.find((section) => section.id === 'playstation').systems,
    },
    {
      id: 'xbox',
      label: 'Xbox consoles',
      systems: ADD_SECTIONS.find((section) => section.id === 'xbox').systems,
    },
    {
      id: 'sega',
      label: 'Sega consoles',
      systems: ADD_SECTIONS.find((section) => section.id === 'sega').systems,
    },
    {
      id: 'other',
      label: 'Other consoles',
      systems: ['3DO', 'Action Max', 'Atari 2600', 'Atari 5200', 'Atari 7800', 'Atari Lynx', 'Colecovision', 'Intellivision', 'Jaguar', 'Jaguar CD', 'Virtual Boy'],
    },
  ];
  const FALLBACK_CONSOLE_VARIANTS = [
    { title: 'NES Control Deck Console', system: 'NES', aliases: ['front loader', 'toaster', 'original nes'] },
    { title: 'NES Top Loader Console', system: 'NES', aliases: ['nes 2', 'nes 101', 'toploader', 'top loader'] },
    { title: 'NES Action Set Console', system: 'NES', aliases: ['super mario bros duck hunt zapper set'] },
    { title: 'NES Deluxe Set Console', system: 'NES', aliases: ['rob set', 'r o b set'] },
    { title: 'Famicom Console', system: 'Famicom', aliases: ['family computer', 'original famicom'], importOnly: true },
    { title: 'AV Famicom Console', system: 'Famicom', aliases: ['new famicom', 'hvc 101'], importOnly: true },
    { title: 'Famicom Disk System', system: 'Famicom Disk System', aliases: ['fds'], importOnly: true },
    { title: 'SNES Console', system: 'Super Nintendo', aliases: ['super nintendo original', 'sns 001'] },
    { title: 'SNES Jr. Console', system: 'Super Nintendo', aliases: ['snes jr', 'snes mini', 'sns 101'] },
    { title: 'Super Famicom Console', system: 'Super Famicom', aliases: ['sfc original'], importOnly: true },
    { title: 'Super Famicom Jr. Console', system: 'Super Famicom', aliases: ['sfc jr', 'super famicom junior'], importOnly: true },
    { title: 'Nintendo 64 Console', system: 'Nintendo 64', aliases: ['n64 charcoal', 'n64 gray', 'n64 grey'] },
    { title: 'Nintendo 64 Funtastic Ice Blue Console', system: 'Nintendo 64', aliases: ['n64 ice blue', 'funtastic blue'] },
    { title: 'Nintendo 64 Funtastic Jungle Green Console', system: 'Nintendo 64', aliases: ['n64 jungle green', 'funtastic green'] },
    { title: 'Nintendo 64 Funtastic Grape Purple Console', system: 'Nintendo 64', aliases: ['n64 grape purple', 'funtastic purple'] },
    { title: 'Nintendo 64 Funtastic Watermelon Red Console', system: 'Nintendo 64', aliases: ['n64 watermelon red', 'funtastic red'] },
    { title: 'Nintendo 64 Funtastic Fire Orange Console', system: 'Nintendo 64', aliases: ['n64 fire orange', 'n64 sun orange', 'funtastic orange'] },
    { title: 'Nintendo 64 Funtastic Smoke Black Console', system: 'Nintendo 64', aliases: ['n64 smoke black', 'funtastic black'] },
    { title: 'Nintendo 64 Pikachu Blue Console', system: 'Nintendo 64', aliases: ['pikachu light blue n64'] },
    { title: 'Nintendo 64 Pikachu Orange Console', system: 'Nintendo 64', aliases: ['orange pikachu n64'] },
    { title: 'Nintendo 64 Gold Console', system: 'Nintendo 64', aliases: ['gold n64'] },
    { title: 'Nintendo GameCube Console', system: 'Gamecube', aliases: ['gamecube system'] },
    { title: 'Wii Console', system: 'Wii', aliases: ['nintendo wii system'] },
    { title: 'Wii U Console', system: 'Wii U', aliases: ['nintendo wii u system'] },
    { title: 'Nintendo Switch Console', system: 'Nintendo Switch', aliases: ['switch system'] },
    { title: 'PlayStation Console', system: 'Playstation', aliases: ['ps1', 'psx'] },
    { title: 'PlayStation 2 Console', system: 'Playstation 2', aliases: ['ps2'] },
    { title: 'PlayStation 3 Console', system: 'Playstation 3', aliases: ['ps3'] },
    { title: 'PlayStation 4 Console', system: 'Playstation 4', aliases: ['ps4'] },
    { title: 'PlayStation 5 Console', system: 'Playstation 5', aliases: ['ps5'] },
    { title: 'PSP 1000 / 1001 Console', system: 'PSP', aliases: ['psp 1000', 'psp 1001', 'psp fat', 'psp phat'] },
    { title: 'PSP 2000 / 2001 Slim Console', system: 'PSP', aliases: ['psp 2000', 'psp 2001', 'psp slim'] },
    { title: 'PSP 3000 / 3001 Brite Console', system: 'PSP', aliases: ['psp 3000', 'psp 3001', 'psp brite'] },
    { title: 'PSP Go Console', system: 'PSP', aliases: ['psp n1000'] },
    { title: 'PSP Street E1000 Console', system: 'PSP', aliases: ['psp e1000', 'psp street'], importOnly: true },
    { title: 'PSP 1000 Piano Black Console', system: 'PSP' },
    { title: 'PSP 1000 Ceramic White Console', system: 'PSP' },
    { title: 'PSP 1000 Ice Silver Console', system: 'PSP' },
    { title: 'PSP 2000 Piano Black Console', system: 'PSP' },
    { title: 'PSP 2000 Ceramic White Console', system: 'PSP', importOnly: true },
    { title: 'PSP 2000 Ice Silver Console', system: 'PSP' },
    { title: 'PSP 2000 Rose Pink Console', system: 'PSP' },
    { title: 'PSP 2000 Felicia Blue Console', system: 'PSP' },
    { title: 'PSP 2000 Deep Red Console', system: 'PSP', importOnly: true },
    { title: 'PSP 2000 God of War Red Console', system: 'PSP' },
    { title: 'PSP 2000 Star Wars White Console', system: 'PSP' },
    { title: 'PSP 3000 Piano Black Console', system: 'PSP' },
    { title: 'PSP 3000 Pearl White Console', system: 'PSP' },
    { title: 'PSP 3000 Mystic Silver Console', system: 'PSP' },
    { title: 'PSP 3000 Radiant Red Console', system: 'PSP', importOnly: true },
    { title: 'PSP 3000 Vibrant Blue Console', system: 'PSP', importOnly: true },
    { title: 'PSP 3000 Spirited Green Console', system: 'PSP', importOnly: true },
    { title: 'PSP 3000 Blossom Pink Console', system: 'PSP', importOnly: true },
    { title: 'PSP 3000 Lilac Purple Console', system: 'PSP', importOnly: true },
    { title: 'PSP 3000 Bright Yellow Console', system: 'PSP', importOnly: true },
    { title: 'PSP 3000 Hannah Montana Purple Console', system: 'PSP' },
    { title: 'PSP 3000 Metal Gear Solid Console', system: 'PSP' },
    { title: 'PSP 3000 Monster Hunter Console', system: 'PSP', importOnly: true },
    { title: 'PSP 3000 Final Fantasy Dissidia Console', system: 'PSP', importOnly: true },
    { title: 'PSP 3000 Kingdom Hearts Console', system: 'PSP', importOnly: true },
    { title: 'PSP 3000 Gran Turismo Console', system: 'PSP' },
    { title: 'PSP 3000 Assassin\'s Creed White Console', system: 'PSP' },
    { title: 'Xbox Console', system: 'Xbox', aliases: ['original xbox'] },
    { title: 'Xbox 360 Console', system: 'Xbox 360', aliases: ['360'] },
    { title: 'Xbox One Console', system: 'Xbox One', aliases: ['xbone'] },
    { title: 'Xbox Series X Console', system: 'Xbox Series X', aliases: ['series x'] },
    { title: 'Sega Master System Console', system: 'Sega Master System', aliases: ['master system'] },
    { title: 'Sega Genesis Console', system: 'Sega Genesis', aliases: ['genesis', 'mega drive'] },
    { title: 'Sega CD Console', system: 'Sega CD', aliases: ['mega cd'] },
    { title: 'Sega Saturn Console', system: 'Sega Saturn', aliases: ['saturn'] },
    { title: 'Sega Dreamcast Console', system: 'Sega Dreamcast', aliases: ['dreamcast'] },
    { title: 'Sega Game Gear Console', system: 'Sega Game Gear', aliases: ['game gear'] },
    { title: 'Atari 2600 Console', system: 'Atari 2600' },
    { title: 'Atari 5200 Console', system: 'Atari 5200' },
    { title: 'Atari 7800 Console', system: 'Atari 7800' },
  ];
  const FALLBACK_CONSOLE_VARIANT_IMAGE_URLS = {
    'NES Control Deck Console': 'https://cdn.consolevariations.com/875/nintendo-entertainment-system.webp',
    'NES Top Loader Console': 'https://cdn.consolevariations.com/874/nintendo-entertainment-system-toploader-transparent.webp',
    'NES Action Set Console': 'https://cdn.consolevariations.com/19635/intendo-entertainment-system-action-set-nes-other-1642406306-96.webp',
    'NES Deluxe Set Console': 'https://cdn.consolevariations.com/2036/nintendo-entertainment-system-deluxe-set-nes-front-1553370308-33-transparent.webp',
    'Famicom Console': 'https://cdn.consolevariations.com/877/nintendo-famicom-transparent.webp',
    'AV Famicom Console': 'https://cdn.consolevariations.com/149/famicom-toploader.webp',
    'Famicom Disk System': 'https://cdn.consolevariations.com/147/famicom-disk-system-first-version.webp',
    'SNES Console': 'https://cdn.consolevariations.com/1457/super-nintendo-north-america-transparent.webp',
    'SNES Jr. Console': 'https://cdn.consolevariations.com/1456/super-nintendo-jr-north-america-transparent.webp',
    'Super Famicom Console': 'https://cdn.consolevariations.com/1452/super-famicom-transparent.webp',
    'Super Famicom Jr. Console': 'https://cdn.consolevariations.com/1451/super-famicom-jr-transparent.webp',
    'Nintendo 64 Console': 'https://cdn.consolevariations.com/504/n64-charcoal.webp',
    'Nintendo 64 Funtastic Ice Blue Console': 'https://cdn.consolevariations.com/527/n64-ice-blue.webp',
    'Nintendo 64 Funtastic Jungle Green Console': 'https://cdn.consolevariations.com/530/n64-jungle-green.webp',
    'Nintendo 64 Funtastic Grape Purple Console': 'https://cdn.consolevariations.com/523/n64-grape-purple.webp',
    'Nintendo 64 Funtastic Watermelon Red Console': 'https://cdn.consolevariations.com/552/n64-watermelon-red.webp',
    'Nintendo 64 Funtastic Fire Orange Console': 'https://cdn.consolevariations.com/518/n64-fire-orange.webp',
    'Nintendo 64 Funtastic Smoke Black Console': 'https://cdn.consolevariations.com/544/n64-smoke-black-transparent.webp',
    'Nintendo 64 Pikachu Blue Console': 'https://cdn.consolevariations.com/539/n64-pikachu-edition-light-blue-transparent.webp',
    'Nintendo 64 Pikachu Orange Console': 'https://cdn.consolevariations.com/540/n64-pikachu-edition-orange-transparent.webp',
    'Nintendo 64 Gold Console': 'https://cdn.consolevariations.com/521/n64-gold.webp',
    'PSP 1000 / 1001 Console': 'https://cdn.consolevariations.com/1385/sony-psp-1000-piano-black-transparent.webp',
    'PSP 2000 / 2001 Slim Console': 'https://cdn.consolevariations.com/1403/sony-psp-2000-piano-black-transparent.webp',
    'PSP 3000 / 3001 Brite Console': 'https://cdn.consolevariations.com/1428/sony-psp-3000-piano-black-transparent.webp',
    'PSP Go Console': 'https://cdn.consolevariations.com/1435/sony-psp-go-black-transparent.webp',
    'PSP Street E1000 Console': 'https://cdn.consolevariations.com/6996/sony-psp-street-e1004-cb-other-1577276080-100.webp',
    'PSP 1000 Piano Black Console': 'https://cdn.consolevariations.com/1385/sony-psp-1000-piano-black-transparent.webp',
    'PSP 1000 Ceramic White Console': 'https://cdn.consolevariations.com/1380/sony-psp-1000-ceramic-white-transparent.webp',
    'PSP 1000 Ice Silver Console': 'https://cdn.consolevariations.com/1384/sony-psp-1000-ice-silver-transparent.webp',
    'PSP 2000 Piano Black Console': 'https://cdn.consolevariations.com/1403/sony-psp-2000-piano-black-transparent.webp',
    'PSP 2000 Ceramic White Console': 'https://cdn.consolevariations.com/1393/sony-psp-2000-ceramic-white-transparent.webp',
    'PSP 2000 Ice Silver Console': 'https://cdn.consolevariations.com/1398/sony-psp-2000-ice-silver-transparent.webp',
    'PSP 2000 Rose Pink Console': 'https://cdn.consolevariations.com/1404/sony-psp-2000-rose-pink-transparent.webp',
    'PSP 2000 Felicia Blue Console': 'https://cdn.consolevariations.com/1395/sony-psp-2000-felicia-blue-transparent.webp',
    'PSP 2000 Deep Red Console': 'https://cdn.consolevariations.com/1394/sony-psp-2000-deep-red-transparent.webp',
    'PSP 2000 God of War Red Console': 'https://cdn.consolevariations.com/1397/sony-psp-2000-god-of-war-chains-of-olympus-transparent.webp',
    'PSP 2000 Star Wars White Console': 'https://cdn.consolevariations.com/29859/sony-psp-2000-star-wars-console-front-view2023-09-17-143133.jpg',
    'PSP 3000 Piano Black Console': 'https://cdn.consolevariations.com/1428/sony-psp-3000-piano-black-transparent.webp',
    'PSP 3000 Pearl White Console': 'https://cdn.consolevariations.com/1427/sony-psp-3000-pearl-white-transparent.webp',
    'PSP 3000 Mystic Silver Console': 'https://cdn.consolevariations.com/7344/sony-playstation-portable-3000-mystic-silver-front-1581608089-97-transparent.webp',
    'PSP 3000 Radiant Red Console': 'https://cdn.consolevariations.com/1413/sony-psp-3000-carnival-radiant-red-transparent.webp',
    'PSP 3000 Vibrant Blue Console': 'https://cdn.consolevariations.com/1415/sony-psp-3000-carnival-vibrant-blue-transparent.webp',
    'PSP 3000 Spirited Green Console': 'https://cdn.consolevariations.com/1414/sony-psp-3000-carnival-spirited-green-transparent.webp',
    'PSP 3000 Blossom Pink Console': 'https://cdn.consolevariations.com/1411/sony-psp-3000-blossom-pink-transparent.webp',
    'PSP 3000 Lilac Purple Console': 'https://cdn.consolevariations.com/1399/sony-psp-2000-lavender-purple-transparent.webp',
    'PSP 3000 Bright Yellow Console': 'https://cdn.consolevariations.com/1412/sony-psp-3000-carnival-bright-yellow-transparent.webp',
    'PSP 3000 Hannah Montana Purple Console': 'https://cdn.consolevariations.com/18966/psp-3000-hannah-montana-bundle-1638712257-18-transparent.webp',
    'PSP 3000 Metal Gear Solid Console': 'https://cdn.consolevariations.com/1423/sony-psp-3000-metal-gear-solid-big-boss-transparent.webp',
    'PSP 3000 Monster Hunter Console': 'https://cdn.consolevariations.com/1425/sony-psp-3000-monster-hunter-3-transparent.webp',
    'PSP 3000 Final Fantasy Dissidia Console': 'https://cdn.consolevariations.com/1416/sony-psp-3000-final-fantasy-dissidia.webp',
    'PSP 3000 Kingdom Hearts Console': 'https://cdn.consolevariations.com/1421/sony-psp-3000-kingdom-hearts-birth-by-sleep-transparent.webp',
    'PSP 3000 Gran Turismo Console': 'https://cdn.consolevariations.com/34542/wWjYD2HIz1SAfo4FobXgfZzNwsN76d-metaR1pJSTRzbVdFQUE5bWhFLmpwZWc=-.jpg',
    'PSP 3000 Assassin\'s Creed White Console': 'https://cdn.consolevariations.com/2775/psp-assassins-creed-bloodline-1553787554-30-transparent.webp',
  };
  const WISHLIST_CONDITION = 'Not owned - add to wishlist';

  function money(value) {
    const amount = Number(value || 0);
    return amount.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  }

  function esc(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function themeAssetUrl(fileName) {
    const clean = String(fileName || '').trim();
    if (!clean) return '';
    if (!THEME_ASSET_BASE_URL) return `./${clean}`;
    try {
      return new URL(clean, THEME_ASSET_BASE_URL).toString();
    } catch (_) {
      return clean;
    }
  }

  function looksLikeEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());
  }

  function normalizeCatalogSystem(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function systemLabel(system) {
    const value = String(system || '').trim();
    if (!value) return '';
    const normalized = normalizeCatalogSystem(value);
    if (normalized === 'all') return 'All systems';
    if (normalized === 'gameboy') return 'Game Boy';
    if (normalized === 'gameboy color') return 'Game Boy Color';
    if (normalized === 'gameboy advance') return 'Game Boy Advance';
    if (normalized === 'playstation vita') return 'PlayStation Vita';
    if (normalized.startsWith('playstation')) return value.replace(/^Playstation/i, 'PlayStation');
    return value;
  }

  function systemInitials(system) {
    const words = systemLabel(system)
      .replace(/[^a-z0-9 ]/gi, ' ')
      .trim()
      .split(/\s+/)
      .filter(Boolean);
    if (!words.length) return 'SYS';
    if (words.length === 1) return words[0].slice(0, 4).toUpperCase();
    return words.slice(0, 3).map((word) => word[0]).join('').toUpperCase();
  }

  function collectionSystemLogoFile(system) {
    const value = normalizeCatalogSystem(system);
    const prefix = 'collection-system-logo-';
    if (!value || value === 'all' || value === 'all systems') return '';
    if (value.includes('amiibo')) return `${prefix}amiibo.png`;
    if (value.includes('skylander')) return `${prefix}skylanders.png`;
    if (value.includes('disney infinity')) return `${prefix}disney_infinity.png`;
    if (value.includes('hyperscan')) return `${prefix}hyperscan.png`;
    if (value.includes('gizmondo')) return `${prefix}gizmondo.png`;
    if (value.includes('action max')) return `${prefix}action_max.png`;
    if (value === '3do' || value.endsWith(' 3do') || value.includes('3do interactive')) return `${prefix}3do_interactive_multiplayer.png`;
    if (value.includes('amstrad gx4000')) return `${prefix}amstrad_gx4000.png`;
    if (value.includes('amstrad')) return `${prefix}amstrad_cpc.svg`;
    if (value.includes('apple pippin') || value.includes('pippin')) return `${prefix}apple_pippin_02.png`;
    if (value.includes('apple ii')) return `${prefix}apple_ii.svg`;
    if (value.includes('arcadia')) return `${prefix}emerson_arcadia_2001.png`;
    if (value.includes('atari 2600')) return `${prefix}atari_2600.png`;
    if (value.includes('atari 2800')) return `${prefix}atari_2800.svg`;
    if (value.includes('atari 400') || value.includes('atari st') || value.includes('atari xe')) return `${prefix}atari.svg`;
    if (value.includes('atari 5200')) return `${prefix}atari_5200.png`;
    if (value.includes('atari 7800')) return `${prefix}atari_7800.png`;
    if (value.includes('jaguar cd')) return `${prefix}atari_jaguar_cd.png`;
    if (value.includes('jaguar')) return `${prefix}atari_jaguar.png`;
    if (value.includes('lynx')) return `${prefix}atari_lynx.png`;
    if (value.includes('bally')) return `${prefix}bally_astrocade.png`;
    if (value.includes('bandai playdia') || value.includes('playdia')) return `${prefix}bandai_playdia.svg`;
    if (value.includes('casio loopy')) return `${prefix}casio_loopy.png`;
    if (value.includes('casio pv')) return `${prefix}casio_pv_1000.png`;
    if (value.includes('coleco')) return `${prefix}colecovision.png`;
    if (value.includes('amiga cd32')) return `${prefix}commodore_amiga_cd32.png`;
    if (value === 'amiga' || value.includes('commodore amiga')) return `${prefix}amiga.svg`;
    if (value.includes('cdtv')) return `${prefix}commodore_cdtv.png`;
    if (value.includes('commodore')) return `${prefix}commodore.svg`;
    if (value.includes('entex')) return `${prefix}entex_adventure_vision.png`;
    if (value.includes('evercade')) return `${prefix}evercade.svg`;
    if (value.includes('fairchild')) return `${prefix}fairchild_channel_f.png`;
    if (value.includes('fm towns')) return `${prefix}fujitsu_fm_towns_marty.png`;
    if (value.includes('game players')) return `${prefix}game_players.svg`;
    if (value.includes('game wave')) return `${prefix}game_wave.svg`;
    if (value.includes('game com')) return `${prefix}tiger_game_com.png`;
    if (value.includes('vectrex')) return `${prefix}gce_vectrex.png`;
    if (value.includes('odyssey 2')) return `${prefix}magnavox_odyssey_2.png`;
    if (value.includes('odyssey')) return `${prefix}magnavox_odyssey.png`;
    if (value.includes('intellivision')) return `${prefix}mattel_intellivision.png`;
    if (value.includes('laseractive')) return `${prefix}laseractive.svg`;
    if (value.includes('msx')) return `${prefix}msx.svg`;
    if (value.includes('neo geo pocket color')) return `${prefix}snk_neo_geo_pocket_color.png`;
    if (value.includes('neo geo pocket')) return `${prefix}snk_neo_geo_pocket.png`;
    if (value.includes('neo geo cd')) return `${prefix}snk_neo_geo_cd.png`;
    if (value.includes('neo geo')) return `${prefix}snk_neo_geo.png`;
    if (value.includes('ngage') || value.includes('n gage')) return `${prefix}nokia_n_gage.png`;
    if (value === 'cd i' || value.includes('cd i')) return `${prefix}philips_cd_i.png`;
    if (value.includes('pc fx')) return `${prefix}nec_pc_fx.png`;
    if (value.includes('gamepro') || value.includes('game pro')) return `${prefix}gamepro.png`;
    if (value.includes('club nintendo')) return `${prefix}club_nintendo.png`;
    if (value === 'egm' || value.includes('electronic gaming monthly')) return `${prefix}electronic_gaming_monthly.jpg`;
    if (value.includes('game informer')) return `${prefix}game_informer.jpg`;
    if (value.includes('nintendo power')) return `${prefix}nintendo_power.png`;
    if (value === 'nes' || value.includes('nintendo entertainment system')) return `${prefix}nintendo_entertainment_system.png`;
    if (value.includes('super nintendo') || value === 'snes') return `${prefix}super_nintendo_entertainment_system.png`;
    if (value.includes('famicom disk')) return `${prefix}nintendo_famicom_disk_system_02.png`;
    if (value.includes('super famicom')) return `${prefix}nintendo_super_famicom.png`;
    if (value.includes('famicom')) return `${prefix}nintendo_famicom.png`;
    if (value.includes('nintendo 64dd')) return `${prefix}nintendo_64dd.png`;
    if (value.includes('nintendo 64') || value === 'n64') return `${prefix}nintendo_64.png`;
    if (value.includes('gamecube')) return `${prefix}nintendo_gamecube.png`;
    if (value === 'wii') return `${prefix}nintendo_wii.png`;
    if (value.includes('wii u')) return `${prefix}nintendo_wii_u.png`;
    if (value.includes('switch')) return `${prefix}nintendo_switch.png`;
    if (value.includes('game and watch')) return `${prefix}nintendo_game_watch.png`;
    if (value.includes('virtual boy')) return `${prefix}nintendo_virtual_boy.png`;
    if (value.includes('new nintendo 3ds')) return `${prefix}new_nintendo_3ds.png`;
    if (value.includes('3ds')) return `${prefix}nintendo_3ds.png`;
    if (value.includes('dsi')) return `${prefix}nintendo_dsi.png`;
    if (value.includes('ds')) return `${prefix}nintendo_ds.png`;
    if (value.includes('game boy advance') || value.includes('gameboy advance') || value === 'gba') return `${prefix}nintendo_game_boy_advance.png`;
    if (value.includes('game boy color') || value.includes('gameboy color')) return `${prefix}nintendo_game_boy_color.png`;
    if (value.includes('game boy') || value.includes('gameboy')) return `${prefix}nintendo_game_boy.png`;
    if (value.includes('playstation 5') || value === 'ps5') return `${prefix}sony_playstation_5.png`;
    if (value.includes('playstation 4') || value === 'ps4') return `${prefix}sony_playstation_4.png`;
    if (value.includes('playstation 3') || value === 'ps3') return `${prefix}sony_playstation_3.png`;
    if (value.includes('playstation 2') || value === 'ps2') return `${prefix}sony_playstation_2.png`;
    if (value.includes('ps vita') || value.includes('vita')) return `${prefix}sony_ps_vita.png`;
    if (value.includes('psp')) return `${prefix}sony_psp.png`;
    if (value.includes('playstation') || value === 'ps1') return `${prefix}sony_playstation.png`;
    if (value.includes('xbox series')) return `${prefix}microsoft_xbox_series.png`;
    if (value.includes('xbox one')) return `${prefix}microsoft_xbox_one.png`;
    if (value.includes('xbox 360')) return `${prefix}microsoft_xbox_360.png`;
    if (value === 'xbox' || value.endsWith(' xbox') || value.includes('microsoft xbox')) return `${prefix}microsoft_xbox.png`;
    if (value.includes('dreamcast')) return `${prefix}sega_dreamcast.png`;
    if (value.includes('genesis')) return `${prefix}sega_genesis.png`;
    if (value.includes('mega drive')) return `${prefix}sega_mega_drive.png`;
    if (value.includes('master system')) return `${prefix}sega_master_system.png`;
    if (value.includes('game gear')) return `${prefix}sega_game_gear.png`;
    if (value.includes('saturn')) return `${prefix}sega_saturn.png`;
    if (value.includes('sega cd') || value.includes('mega cd')) return `${prefix}sega_cd.png`;
    if (value.includes('32x')) return `${prefix}sega_32x.png`;
    if (value.includes('pc engine supergrafx')) return `${prefix}nec_pc_engine_supergrafx.png`;
    if (value.includes('pc engine cd')) return `${prefix}nec_pc_engine_cd_7_10.png`;
    if (value.includes('pc engine')) return `${prefix}nec_pc_engine_7_03.png`;
    if (value.includes('turbo duo')) return `${prefix}nec_turbo_duo_13.png`;
    if (value.includes('turbografx cd')) return `${prefix}nec_turbografx_cd.png`;
    if (value.includes('turbografx')) return `${prefix}nec_turbografx_16.png`;
    return '';
  }

  function systemLogoHtml(system, modifier = '') {
    const fileName = collectionSystemLogoFile(system);
    const className = `cavern-collection__system-logo-well${modifier ? ` ${modifier}` : ''}`;
    if (fileName) {
      return `<div class="${className}">
        <img src="${esc(themeAssetUrl(fileName))}" alt="" loading="lazy">
      </div>`;
    }

    return `<div class="${className}">
      <span>${esc(systemInitials(system))}</span>
    </div>`;
  }

  function catalogFallbackImageHtml(item) {
    if (isConsoleCatalogItem(item) && catalogSystemForItem(item)) {
      return systemLogoHtml(catalogSystemForItem(item), 'cavern-collection__system-logo-well--cover');
    }
    return catalogImagePlaceholderHtml(item);
  }

  function systemCanHaveConsoleShortcut(system) {
    const normalized = normalizeCatalogSystem(system);
    if (!normalized || normalized === 'all') return false;
    if (isMagazineCatalogSystem(normalized)) return false;

    const blocked = [
      'amiibo',
      'skylander',
      'disney infinity',
      'club nintendo',
      'electronic gaming monthly',
      'egm',
      'game informer',
      'gamepro',
      'nintendo power',
      'tips and tricks',
    ];
    return !blocked.some((token) => normalized.includes(token));
  }

  function isImportCatalogSystem(normalizedSystem) {
    return normalizedSystem.startsWith('jp ') ||
      normalizedSystem.startsWith('asian english ') ||
      IMPORT_CATALOG_SYSTEMS.has(normalizedSystem);
  }

  function isMagazineCatalogSystem(normalizedSystem) {
    return normalizedSystem.includes('magazine') ||
      MAGAZINE_CATALOG_SYSTEMS.has(normalizedSystem);
  }

  function readCatalogFilterSettings() {
    try {
      const parsed = JSON.parse(localStorage.getItem(CATALOG_FILTER_KEY) || '{}');
      return {
        ...DEFAULT_CATALOG_FILTER_SETTINGS,
        includeImports: parsed.includeImports === true,
        includeComputers: parsed.includeComputers === true,
        includeMagazines: parsed.includeMagazines === undefined
          ? DEFAULT_CATALOG_FILTER_SETTINGS.includeMagazines
          : parsed.includeMagazines === true,
      };
    } catch (_) {
      return { ...DEFAULT_CATALOG_FILTER_SETTINGS };
    }
  }

  function catalogSystemForItem(item) {
    return item?.consoleName || item?.console || item?.platform || item?.system || '';
  }

  function itemImage(item) {
    const url = item?.imageUrl || item?.sourceImageUrl || '';
    if (!url) return '';
    return `<img src="${esc(url)}" alt="" loading="lazy" onerror="this.hidden=true">`;
  }

  function catalogImagePlaceholderHtml(item) {
    const title = catalogTitle(item);
    const system = catalogSystemForItem(item);
    const type = catalogItemType(item);
    const rawPrimary = String(title || system || type || 'Catalog item')
      .replace(/\s*\[[^\]]+\]\s*$/g, '')
      .trim();
    const rawSecondary = String(
      type && String(type).toLowerCase() !== 'game'
        ? type
        : system || type || 'Catalog item'
    ).trim();
    return `<div class="cavern-collection__catalog-card-placeholder" aria-hidden="true">
      <strong>${esc(rawPrimary || 'Catalog item')}</strong>
      <span>${esc(rawSecondary || 'Catalog item')}</span>
    </div>`;
  }

  function catalogImageHtml(item) {
    const image = itemImage(item);
    const fallback = catalogFallbackImageHtml(item);
    return image ? `${image}${fallback}` : fallback;
  }

  function conditionValue(game, condition) {
    const loose = Number(game.looseValue || game.loosePrice || 0);
    const complete = Number(game.completeValue || game.completePrice || game.cibPrice || 0);
    const sealed = Number(game.newValue || game.newPrice || 0);
    const box = Number(game.boxOnlyValue || game.boxOnlyPrice || 0);
    const manual = Number(game.manualOnlyValue || game.manualOnlyPrice || 0);
    const normalized = String(condition || '').toLowerCase();

    if (normalized.includes('new') || normalized.includes('sealed')) {
      return sealed || complete || loose;
    }
    if (normalized.includes('complete')) {
      return complete || loose;
    }
    if (normalized.includes('case')) {
      return complete && manual ? Math.max(complete - manual, loose) : complete || loose;
    }
    if (normalized.includes('manual') || normalized.includes('poster')) {
      return manual || (complete ? complete * 0.25 : loose * 0.25);
    }
    if (normalized.includes('box')) {
      return box || (complete ? complete * 0.25 : loose * 0.25);
    }
    return loose || complete;
  }

  function hasCatalogPrice(game) {
    return [
      game?.looseValue,
      game?.loosePrice,
      game?.completeValue,
      game?.completePrice,
      game?.cibPrice,
      game?.newValue,
      game?.newPrice,
      game?.boxOnlyValue,
      game?.boxOnlyPrice,
      game?.manualOnlyValue,
      game?.manualOnlyPrice,
    ].some((value) => Number(value || 0) > 0);
  }

  function catalogTitle(game) {
    return game?.title || game?.name || '';
  }

  function catalogItemType(game) {
    return game?.itemType || game?.type || 'Game';
  }

  function catalogPriceNumber(game, keys) {
    for (const key of keys) {
      const amount = Number(game?.[key] || 0);
      if (amount > 0) return amount;
    }
    return 0;
  }

  function normalizeCatalogSystemForHardware(system) {
    return normalizeCatalogSystem(system)
      .replace(/^(?:jp|japanese|pal|eu|european|us|usa|asian english)\s+/, '');
  }

  function isConsoleCatalogItem(game) {
    const rawTitle = String(catalogTitle(game) || '').trim();
    const title = rawTitle.toLowerCase();
    if (!title) return false;
    const normalizedTitle = normalizeCatalogSystem(rawTitle);

    const blockedPhrases = [
      'console edition',
      'in the system',
      'system shock',
      'system of souls',
      'system redux',
      'system flaw',
      'risk system',
      'visible solar system',
      'authoring system',
      'animation system',
      'blood glucose',
    ];
    if (blockedPhrases.some((phrase) => title.includes(phrase)) || title.includes(':')) {
      return false;
    }

    const itemType = normalizeCatalogSystem(catalogItemType(game));
    if (itemType.includes('console') || itemType.includes('hardware')) return true;

    if (/^psp\s+(go|e?\d{3,4})\b/.test(normalizedTitle)) return true;
    if (/^playstation\s+(portable|vita|tv)\b/.test(normalizedTitle)) return true;

    const hasHardwareWord = /\b(system|console)\b/.test(title);
    if (!hasHardwareWord) return false;

    const endsLikeHardware = /\b(system|console)(\s*\[[^\]]+\])?$/.test(title);
    const hasBracketedHardware = /\b(system|console)\s*\[/.test(title);
    if (endsLikeHardware || hasBracketedHardware) return true;

    const normalizedSystem = normalizeCatalogSystemForHardware(catalogSystemForItem(game));
    return normalizedSystem &&
      normalizedTitle.startsWith(normalizedSystem) &&
      hasHardwareWord;
  }

  function catalogGameWithBestPrice(game, priceSources, settings) {
    if (hasCatalogPrice(game) || !isConsoleCatalogItem(game)) return game;

    const source = bestCatalogPriceSource(game, priceSources, settings);
    if (!source) return game;

    return {
      ...game,
      priceChartingId: preferredCatalogText(source?.priceChartingId, game?.priceChartingId),
      upc: preferredCatalogText(source?.upc, game?.upc),
      looseValue: catalogPriceNumber(source, ['looseValue', 'loosePrice']),
      completeValue: catalogPriceNumber(source, ['completeValue', 'completePrice', 'cibPrice']),
      newValue: catalogPriceNumber(source, ['newValue', 'newPrice']),
      boxOnlyValue: catalogPriceNumber(source, ['boxOnlyValue', 'boxOnlyPrice']),
      manualOnlyValue: catalogPriceNumber(source, ['manualOnlyValue', 'manualOnlyPrice']),
    };
  }

  function bestCatalogPriceSource(target, sources, settings) {
    let best = null;
    let bestScore = 0;

    for (const source of Array.isArray(sources) ? sources : []) {
      if (!hasCatalogPrice(source)) continue;
      if (!catalogSettingsAllowSystem(settings, catalogSystemForItem(source))) continue;
      if (!isConsoleCatalogItem(source)) continue;

      const score = catalogPriceMatchScore(target, source);
      if (score > bestScore) {
        best = source;
        bestScore = score;
      }
    }

    return bestScore >= 80 ? best : null;
  }

  function catalogPriceMatchScore(target, source) {
    const targetSystems = catalogPriceSystemTerms(catalogSystemForItem(target));
    const sourceSystems = catalogPriceSystemTerms(catalogSystemForItem(source));
    if (![...targetSystems].some((term) => sourceSystems.has(term))) return 0;

    const targetTitle = normalizeCatalogSystem(catalogTitle(target));
    const sourceTitle = normalizeCatalogSystem(catalogTitle(source));
    if (!targetTitle || !sourceTitle) return 0;
    if (targetTitle === sourceTitle) return 220;
    if (
      normalizedSearchMatches(targetTitle, sourceTitle) ||
      normalizedSearchMatches(sourceTitle, targetTitle)
    ) {
      return 170;
    }

    const targetTokens = catalogPriceTokens(`${catalogTitle(target)} ${catalogSystemForItem(target)}`);
    const sourceTokens = catalogPriceTokens(`${catalogTitle(source)} ${catalogSystemForItem(source)}`);
    const shared = [...targetTokens].filter((token) => sourceTokens.has(token));
    if (shared.length < 2) return 0;

    const smallerTokenCount = Math.min(targetTokens.size, sourceTokens.size);
    const coverage = smallerTokenCount ? shared.length / smallerTokenCount : 0;
    const exactSystemBonus = normalizeCatalogSystem(catalogSystemForItem(target)) ===
      normalizeCatalogSystem(catalogSystemForItem(source))
      ? 30
      : 0;

    return 50 + (shared.length * 18) + Math.round(coverage * 60) + exactSystemBonus;
  }

  function catalogPriceSystemTerms(system) {
    const normalized = normalizeCatalogSystem(system);
    const terms = new Set(systemSearchTerms(system));
    const stripped = normalized.replace(/^(?:jp|japanese|pal|eu|european|us|usa|asian english)\s+/, '');
    if (stripped && stripped !== normalized) {
      terms.add(stripped);
      systemSearchTerms(stripped).forEach((term) => terms.add(term));
    }
    return new Set([...terms].filter(Boolean));
  }

  function catalogPriceTokens(value) {
    const stopWords = new Set([
      'and',
      'bundle',
      'console',
      'edition',
      'english',
      'hardware',
      'japanese',
      'limited',
      'microsoft',
      'na',
      'nintendo',
      'north',
      'pack',
      'sony',
      'system',
      'the',
      'us',
      'usa',
      'version',
    ]);
    return new Set(
      normalizeCatalogSystem(value)
        .split(' ')
        .filter((token) => token.length > 1 && !stopWords.has(token))
    );
  }

  function preferredCatalogText(preferred, fallback) {
    const trimmedPreferred = String(preferred || '').trim();
    if (trimmedPreferred) return trimmedPreferred;
    const trimmedFallback = String(fallback || '').trim();
    return trimmedFallback || undefined;
  }

  function isLikelyUpc(value) {
    return /^\d{8,14}$/.test(String(value || '').trim().replace(/\D/g, ''));
  }

  function normalizedSystemSet(systems) {
    return new Set((Array.isArray(systems) ? systems : []).map(normalizeCatalogSystem).filter(Boolean));
  }

  function normalizedSearchMatches(searchable, normalizedQuery) {
    if (!normalizedQuery) return true;
    if (searchable.includes(normalizedQuery)) return true;
    const terms = normalizedQuery.split(' ').filter(Boolean);
    return terms.length >= 2 && terms.every((term) => searchable.includes(term));
  }

  function systemSearchTerms(system) {
    const normalized = normalizeCatalogSystem(system);
    const terms = new Set([normalized]);
    const aliases = {
      nes: ['nintendo entertainment system', 'nintendo nes'],
      famicom: ['family computer', 'fc'],
      'famicom disk system': ['fds'],
      'super nintendo': ['snes', 'super nes', 'super nintendo entertainment'],
      'nintendo 64': ['n64'],
      gameboy: ['game boy', 'gb'],
      'gameboy color': ['game boy color', 'gbc'],
      'gameboy advance': ['game boy advance', 'gba'],
      'nintendo ds': ['ds'],
      'nintendo 3ds': ['3ds'],
      playstation: ['ps1', 'psx', 'sony playstation'],
      'playstation 2': ['ps2', 'sony playstation 2'],
      'playstation 3': ['ps3', 'sony playstation 3'],
      'playstation 4': ['ps4', 'sony playstation 4'],
      'playstation 5': ['ps5', 'sony playstation 5'],
      'playstation vita': ['vita', 'ps vita'],
      psp: ['playstation portable'],
      'xbox 360': ['360'],
      'xbox one': ['xbone'],
      'xbox series x': ['series x', 'xbox series'],
      'sega dreamcast': ['dreamcast'],
      'sega saturn': ['saturn'],
      'sega genesis': ['genesis', 'mega drive'],
      'sega master system': ['master system'],
      'sega game gear': ['game gear'],
      'sega 32x': ['32x'],
    };

    (aliases[normalized] || []).forEach((term) => terms.add(term));
    if (normalized.includes('psp')) terms.add('playstation portable');
    if (normalized.includes('famicom')) terms.add('family computer');
    if (normalized.includes('vita')) terms.add('ps vita');
    if (normalized.includes('nintendo 64')) terms.add('n64');
    if (normalized.includes('super nintendo')) terms.add('snes');
    if (normalized.includes('gameboy') || normalized.includes('game boy')) {
      terms.add('game boy');
      terms.add('gameboy');
    }
    return Array.from(terms).filter(Boolean);
  }

  function systemsOverlap(left, right) {
    const leftTerms = new Set(systemSearchTerms(left));
    return systemSearchTerms(right).some((term) => leftTerms.has(term));
  }

  function catalogGameMatchesSearch(game, normalizedQuery) {
    if (!normalizedQuery) return true;
    const searchable = normalizeCatalogSystem([
      game?.id,
      game?.priceChartingId,
      game?.upc,
      catalogTitle(game),
      catalogSystemForItem(game),
      catalogItemType(game),
      Array.isArray(game?.aliases) ? game.aliases.join(' ') : '',
    ].filter(Boolean).join(' '));
    return normalizedSearchMatches(searchable, normalizedQuery) ||
      systemSearchTerms(catalogSystemForItem(game)).includes(normalizedQuery);
  }

  function consoleRemoteSearchQuery(query) {
    const normalized = normalizeCatalogSystem(query);
    const aliases = {
      snes: 'super nintendo',
      'super nes': 'super nintendo',
      n64: 'nintendo 64',
      gb: 'gameboy',
      'game boy': 'gameboy',
      gbc: 'game boy',
      'game boy color': 'game boy',
      gba: 'game boy advance',
      ds: 'nintendo ds',
      '3ds': 'nintendo 3ds',
      vita: 'playstation vita',
      'ps vita': 'playstation vita',
      ps1: 'playstation',
      psx: 'playstation',
      ps2: 'playstation 2',
      ps3: 'playstation 3',
      ps4: 'playstation 4',
      ps5: 'playstation 5',
      saturn: 'sega saturn',
      dreamcast: 'sega dreamcast',
      genesis: 'sega genesis',
    };
    return aliases[normalized] || query;
  }

  function consoleVariationString(item, key) {
    const value = item?.[key];
    if (typeof value === 'string' && value.trim()) return value.trim();
    if (typeof value === 'number') return String(value);
    return '';
  }

  function consoleVariationSystemLabel(platform) {
    const normalized = normalizeCatalogSystem(platform);
    if (normalized.includes('sony psp') || normalized.includes('playstation portable') || normalized.includes('psp go')) return 'PSP';
    if (normalized.includes('playstation vita')) return 'Playstation Vita';
    if (normalized.includes('sony playstation 5')) return 'Playstation 5';
    if (normalized.includes('sony playstation 4')) return 'Playstation 4';
    if (normalized.includes('sony playstation 3')) return 'Playstation 3';
    if (normalized.includes('sony playstation 2')) return 'Playstation 2';
    if (normalized === 'sony playstation' || normalized.includes('sony playstation 1')) return 'Playstation';
    if (normalized.includes('new nintendo 2ds') || normalized.includes('nintendo 2ds') || normalized.includes('new nintendo 3ds') || normalized.includes('nintendo 3ds')) return 'Nintendo 3DS';
    if (normalized.includes('nintendo ds')) return 'Nintendo DS';
    if (normalized.includes('game boy advance')) return 'GameBoy Advance';
    if (normalized.includes('game boy color')) return 'GameBoy Color';
    if (normalized.includes('game boy')) return 'GameBoy';
    if (normalized.includes('gamecube')) return 'Gamecube';
    if (normalized.includes('nintendo 64')) return 'Nintendo 64';
    if (normalized === 'nes') return 'NES';
    if (normalized === 'snes') return 'Super Nintendo';
    if (normalized.includes('famicom disk system')) return 'Famicom Disk System';
    if (normalized.includes('famicom')) return 'Famicom';
    if (normalized.includes('nintendo wii u')) return 'Wii U';
    if (normalized.includes('nintendo wii')) return 'Wii';
    if (normalized.includes('nintendo switch')) return 'Nintendo Switch';
    if (normalized.includes('virtual boy')) return 'Virtual Boy';
    if (normalized.includes('microsoft xbox series')) return 'Xbox Series X';
    if (normalized.includes('microsoft xbox one')) return 'Xbox One';
    if (normalized.includes('microsoft xbox 360')) return 'Xbox 360';
    if (normalized === 'microsoft xbox') return 'Xbox';
    if (normalized.includes('sega dreamcast')) return 'Sega Dreamcast';
    if (normalized.includes('sega saturn')) return 'Sega Saturn';
    if (normalized.includes('sega 32x')) return 'Sega 32X';
    if (normalized.includes('sega mega cd') || normalized.includes('sega cd')) return 'Sega CD';
    if (normalized.includes('sega genesis') || normalized.includes('mega drive')) return 'Sega Genesis';
    if (normalized.includes('sega master system')) return 'Sega Master System';
    if (normalized.includes('sega game gear')) return 'Sega Game Gear';
    return platform;
  }

  function consoleVariationGamesFromJson(decoded) {
    if (!Array.isArray(decoded)) return { games: [], regionsById: {} };
    const games = [];
    const regionsById = {};
    const seen = new Set();
    decoded.forEach((item) => {
      if (!item || consoleVariationString(item, 'y') !== 'consoles') return;
      const title = consoleVariationString(item, 'n');
      const platform = consoleVariationString(item, 'p');
      const imageUrl = consoleVariationString(item, 'i');
      if (!title || !platform || !imageUrl) return;
      const slug = consoleVariationString(item, 's') || normalizeCatalogSystem(`${platform} ${title}`).replace(/\s+/g, '-');
      const id = `console_variation_${slug}`;
      if (seen.has(id)) return;
      seen.add(id);
      const region = consoleVariationString(item, 're');
      if (region) regionsById[id] = region;
      games.push({
        id,
        title,
        consoleName: consoleVariationSystemLabel(platform),
        itemType: 'Console',
        imageUrl,
        looseValue: 0,
        completeValue: 0,
        newValue: 0,
        boxOnlyValue: 0,
        manualOnlyValue: 0,
      });
    });
    return { games: games.sort(compareConsoleCatalogRows), regionsById };
  }

  function consoleVariationRegionMarkers(title) {
    return Array.from(String(title || '').matchAll(/\[([^\]]+)\]/g))
      .map((match) => normalizeCatalogSystem(match[1]))
      .filter(Boolean);
  }

  function regionMarkerIsAmerican(marker) {
    return ['can', 'canada', 'mx', 'mexico', 'na', 'north america', 'us', 'usa', 'united states'].includes(marker);
  }

  function regionMarkerIsImport(marker) {
    return ['asia', 'asian', 'au', 'aus', 'australia', 'br', 'brazil', 'china', 'cn', 'de', 'eu', 'eur', 'europe', 'fr', 'gr', 'hk', 'hong kong', 'it', 'jp', 'jpn', 'japan', 'kor', 'korea', 'pal', 'sea', 'tw', 'taiwan', 'uk'].includes(marker);
  }

  function consoleVariationRegionIsAmerican(region, title) {
    const markers = consoleVariationRegionMarkers(title);
    if (markers.some((marker) => !regionMarkerIsAmerican(marker) && regionMarkerIsImport(marker))) return false;
    const normalizedRegion = normalizeCatalogSystem(region);
    if (normalizedRegion === 'na' || normalizedRegion === 'ww') return true;
    if (!normalizedRegion) return markers.some(regionMarkerIsAmerican);
    return false;
  }

  function fallbackConsoleVariantAllowed(variant, settings) {
    return catalogSettingsAllowSystem(settings, variant.system) &&
      (settings.includeImports || variant.importOnly !== true);
  }

  function fallbackConsoleVariantGame(variant) {
    const normalized = normalizeCatalogSystem(`${variant.system} ${variant.title}`).replace(/\s+/g, '_');
    return {
      id: `fallback_console_variant_${normalized}`,
      title: variant.title,
      consoleName: variant.system,
      itemType: 'Console',
      aliases: variant.aliases || [],
      imageUrl: FALLBACK_CONSOLE_VARIANT_IMAGE_URLS[variant.title],
      looseValue: 0,
      completeValue: 0,
      newValue: 0,
      boxOnlyValue: 0,
      manualOnlyValue: 0,
    };
  }

  function syntheticConsoleCatalogGame(system) {
    const label = String(system || '').trim();
    const normalized = normalizeCatalogSystem(label).replace(/\s+/g, '_');
    return {
      id: `synthetic_console_${normalized}`,
      title: `${label} Console`,
      consoleName: label,
      itemType: 'Console',
      looseValue: 0,
      completeValue: 0,
      newValue: 0,
      boxOnlyValue: 0,
      manualOnlyValue: 0,
    };
  }

  function consoleRowSourceRank(game) {
    const id = String(game?.id || '');
    if (id.startsWith('console_variation_')) return 0;
    if (id.startsWith('fallback_console_variant_')) return 1;
    if (id.startsWith('synthetic_console_')) return 3;
    return 2;
  }

  function compareConsoleCatalogRows(left, right) {
    const sourceSort = consoleRowSourceRank(left) - consoleRowSourceRank(right);
    if (sourceSort) return sourceSort;
    const systemSort = String(catalogSystemForItem(left)).localeCompare(String(catalogSystemForItem(right)));
    if (systemSort) return systemSort;
    const titleRankSort = consoleTitleRank(left) - consoleTitleRank(right);
    if (titleRankSort) return titleRankSort;
    return String(catalogTitle(left)).localeCompare(String(catalogTitle(right)));
  }

  function consoleTitleRank(game) {
    const title = normalizeCatalogSystem(catalogTitle(game));
    const system = normalizeCatalogSystem(catalogSystemForItem(game));
    if (system && (title === `${system} console` || title.startsWith(`${system} console `))) return 0;
    if (/\b(console|system)\b/.test(title) && !/\b(bundle|package|controller)\b/.test(title)) return 1;
    if (/\b(console|system)\b/.test(title)) return 2;
    if (/\b(bundle|package|controller|phone)\b/.test(title)) return 4;
    return 3;
  }

  function catalogSettingsAllowSystem(settings, system) {
    const normalized = normalizeCatalogSystem(system);
    if (!normalized || normalized === 'all') return true;
    if (isMagazineCatalogSystem(normalized) && !settings.includeMagazines) return false;
    if (isImportCatalogSystem(normalized) && !settings.includeImports) return false;
    if (COMPUTER_CATALOG_SYSTEMS.has(normalized) && !settings.includeComputers) return false;
    return true;
  }

  class CavernCollectionApp extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.endpoint = String(this.dataset.endpoint || '').replace(/\/+$/, '');
      this.accountUrl = this.dataset.accountUrl || '/account/register';
      this.root = this.querySelector('[data-collection-root]');
      this.status = this.querySelector('[data-collection-status]');
      this.token = localStorage.getItem(TOKEN_KEY) || '';
      this.email = localStorage.getItem(EMAIL_KEY) || this.dataset.customerEmail || '';
      this.appDownloadUrl = this.resolveAppDownloadUrl(this.dataset.appDownloadUrl);
      this.activeTab = 'collection';
      this.collection = [];
      this.wishlist = [];
      this.catalogResults = [];
      this.catalogResultsTitle = '';
      this.catalogResultsHelp = '';
      this.catalogResultsEmpty = '';
      this.catalogResultsMode = 'catalog';
      this.catalogSystems = FALLBACK_CATALOG_SYSTEMS;
      this.catalogSystemsError = '';
      this.catalogFilterSettings = readCatalogFilterSettings();
      this.consoleVariationCatalog = [];
      this.consoleVariationRegionsById = {};
      this.consoleVariationCatalogLoad = null;
      this.addView = 'home';
      this.addContext = null;
      this.editingItemId = '';
      this.manualAddOpen = false;
      this.canScanBarcodes = 'BarcodeDetector' in window && 'createImageBitmap' in window;
      this.busy = false;
      this.busyMessage = '';

      this.addEventListener('click', this.handleClick.bind(this));
      this.addEventListener('submit', this.handleSubmit.bind(this));
      this.addEventListener('change', this.handleChange.bind(this));

      this.bootstrapSession();
    }

    setStatus(message, isError = false) {
      if (!this.status) return;
      this.status.innerHTML = message
        ? `<div class="cavern-collection__notice${isError ? ' cavern-collection__notice--error' : ''}">${esc(message)}</div>`
        : '';
      if (this.busy && message && !isError) {
        this.busyMessage = message;
        this.updateBusyIndicator();
      }
    }

    setBusy(value, message = '') {
      this.busy = Boolean(value);
      this.busyMessage = this.busy ? (message || this.busyMessage || 'Loading...') : '';
      if (typeof this.toggleAttribute === 'function') {
        this.toggleAttribute('aria-busy', this.busy);
      } else if (typeof this.setAttribute === 'function' && typeof this.removeAttribute === 'function') {
        if (this.busy) this.setAttribute('aria-busy', 'true');
        else this.removeAttribute('aria-busy');
      }
      this.updateBusyIndicator();
      this.querySelectorAll('button, input, select, textarea').forEach((control) => {
        control.disabled = this.busy;
      });
    }

    updateBusyIndicator() {
      if (typeof document === 'undefined' || !document.createElement || typeof this.querySelector !== 'function') return;

      const existing = this.querySelector('[data-collection-busy]');
      if (!this.busy) {
        if (existing) existing.remove();
        return;
      }

      const message = this.busyMessage || 'Loading...';
      let indicator = existing;
      if (!indicator) {
        indicator = document.createElement('div');
        indicator.className = 'cavern-collection__busy';
        indicator.setAttribute('data-collection-busy', '');
        indicator.setAttribute('role', 'status');
        indicator.setAttribute('aria-live', 'polite');
        indicator.innerHTML = `
          <span class="cavern-collection__busy-spinner" aria-hidden="true"></span>
          <span data-collection-busy-message></span>
        `;
        const anchor = this.status || this.root || this;
        if (anchor?.insertAdjacentElement) {
          anchor.insertAdjacentElement('afterend', indicator);
        } else if (this.prepend) {
          this.prepend(indicator);
        }
      }

      const messageElement = indicator.querySelector('[data-collection-busy-message]');
      if (messageElement) messageElement.textContent = message;
    }

    submitBusyMessage(action) {
      return {
        'request-code': 'Sending verification code...',
        'verify-code': 'Checking verification code...',
        'account-help': 'Sending account help request...',
        'catalog-search': 'Searching the catalog...',
        'upc-search': 'Looking up barcode...',
        'add-catalog-form': 'Adding item to your collection...',
        'manual-add': 'Adding item to your collection...',
        'save-item': 'Saving item...',
        'wishlist-manual': 'Adding wishlist alert...',
        'sell-submit': 'Submitting sell/trade review...',
        'save-catalog-settings': 'Saving catalog settings...',
      }[action] || 'Working...';
    }

    clickBusyMessage(action, button) {
      const system = systemLabel(button?.dataset?.system || '');
      return {
        logout: 'Logging out...',
        'browse-all-catalog': 'Loading all systems...',
        'browse-catalog-system': system ? `Loading ${system}...` : 'Loading system...',
        'search-console-system': system ? `Loading ${system} console variants...` : 'Loading console variants...',
        'scan-barcode': 'Opening barcode scanner...',
        'wishlist-catalog': 'Adding wishlist alert...',
        'delete-item': 'Removing item...',
        'mark-sold': 'Marking item sold...',
        'sold-to-cavern': 'Marking item sold...',
        'sold-elsewhere': 'Marking item sold...',
        'unsubmit-item': 'Keeping item in collection...',
        'delete-wishlist': 'Removing wishlist alert...',
      }[action] || '';
    }

    resolveAppDownloadUrl(value) {
      const fallback = 'https://play.google.com/store/apps/details?id=com.thepurpleeagle.myvgcbeta';
      const target = String(value || fallback).trim() || fallback;
      try {
        const origin = window.location?.origin || 'https://thevideogamecavern.com';
        return new URL(target, origin).toString();
      } catch (_) {
        return target;
      }
    }

    appDownloadQrUrl() {
      return `https://api.qrserver.com/v1/create-qr-code/?size=190x190&margin=10&data=${encodeURIComponent(this.appDownloadUrl)}`;
    }

    async request(path, options = {}) {
      const headers = {
        'Content-Type': 'application/json',
        ...(options.headers || {}),
      };
      if (this.token) {
        headers.Authorization = `Bearer ${this.token}`;
      }

      const response = await fetch(`${this.endpoint}${path}`, {
        ...options,
        headers,
        credentials: 'include',
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok || data.success === false) {
        if (response.status === 401) {
          this.logout(false);
        }
        const error = new Error(data.message || 'Request failed.');
        error.status = response.status;
        throw error;
      }
      return data;
    }

    renderAuth(helpOpen = false) {
      this.setStatus('');
      const emailValue = esc(this.email);
      this.root.innerHTML = `
        <div class="cavern-collection__auth cavern-collection__panel">
          <p class="cavern-collection__kicker">Secure sign in</p>
          <h2>Use your Cavern account email</h2>
          <p class="cavern-collection__help-copy">Your collection is private. Verify your email to load the same collection used in the Cavern app.</p>
          <div class="cavern-collection__signin-guide">
            <strong>How to see your collection</strong>
            <ol>
              <li>Enter the email used for your Cavern account.</li>
              <li>Check your inbox for the verification code.</li>
              <li>Enter the code here and your collection will load.</li>
            </ol>
            <p>If you do not have a website account yet, create one first, then come back here and verify that email.</p>
          </div>
          <form class="cavern-collection__form" data-action="request-code">
            <div class="cavern-collection__field">
              <label for="CollectionEmail">Email</label>
              <input id="CollectionEmail" type="email" name="email" value="${emailValue}" autocomplete="email" required>
            </div>
            <div class="cavern-collection__actions">
              <button class="cavern-collection__button" type="submit">Send code</button>
              <a class="cavern-collection__button cavern-collection__button--secondary" href="${esc(this.accountUrl)}">Create account</a>
            </div>
          </form>
          ${helpOpen ? this.helpFormHtml() : `
            <p class="cavern-collection__help-copy">If your email is not found, you can create a new account or request help finding an older account that may be under a phone number.</p>
            <button class="cavern-collection__button cavern-collection__button--secondary" type="button" data-action="show-help">Request account help</button>
          `}
        </div>
      `;
    }

    renderCodeForm(email) {
      this.root.innerHTML = `
        <div class="cavern-collection__auth cavern-collection__panel">
          <p class="cavern-collection__kicker">Check your email</p>
          <h2>Enter the verification code</h2>
          <p class="cavern-collection__help-copy">We sent a code to ${esc(email)}. It expires in 5 minutes.</p>
          <form class="cavern-collection__form" data-action="verify-code">
            <input type="hidden" name="email" value="${esc(email)}">
            <div class="cavern-collection__field">
              <label for="CollectionCode">Verification code</label>
              <input id="CollectionCode" type="text" name="code" inputmode="numeric" autocomplete="one-time-code" required>
            </div>
            <div class="cavern-collection__actions">
              <button class="cavern-collection__button" type="submit">Verify</button>
              <button class="cavern-collection__button cavern-collection__button--secondary" type="button" data-action="back-login">Use another email</button>
            </div>
          </form>
        </div>
      `;
    }

    helpFormHtml() {
      return `
        <div class="cavern-collection__panel" style="margin-top:1.6rem;">
          <h3>Request help finding an older account</h3>
          <p class="cavern-collection__help-copy">Requests are reviewed manually and may take up to 48 hours. We respect your privacy, and this request is sent to the store by email for staff review. We may ask for more information before updating an account. The fastest options are to create a new account or visit us in-store so we can help verify your account directly.</p>
          <form class="cavern-collection__form" data-action="account-help">
            <div class="cavern-collection__grid cavern-collection__grid--two">
              <div class="cavern-collection__field">
                <label for="CollectionHelpName">Full name</label>
                <input id="CollectionHelpName" name="name" required>
              </div>
              <div class="cavern-collection__field">
                <label for="CollectionHelpPhone">Phone number</label>
                <input id="CollectionHelpPhone" name="phone" autocomplete="tel">
              </div>
            </div>
            <div class="cavern-collection__field">
              <label for="CollectionHelpEmail">Email you want to use</label>
              <input id="CollectionHelpEmail" type="email" name="email" value="${esc(this.email)}" required>
            </div>
            <div class="cavern-collection__field">
              <label for="CollectionHelpNote">Note</label>
              <textarea id="CollectionHelpNote" name="note" placeholder="Anything that may help us find the account"></textarea>
            </div>
            <label class="cavern-collection__checkbox-row">
              <input type="checkbox" name="accepted" required>
              <span>I understand this request may take up to 48 hours and does not guarantee account access.</span>
            </label>
            <div class="cavern-collection__actions">
              <button class="cavern-collection__button" type="submit">Send help request</button>
              <button class="cavern-collection__button cavern-collection__button--secondary" type="button" data-action="back-login">Back to login</button>
            </div>
          </form>
        </div>
      `;
    }

    renderApp() {
      const itemCount = this.collection
        .filter((item) => !item.soldAt)
        .reduce((sum, item) => sum + Number(item.quantity || 1), 0);
      const totalValue = this.collection
        .filter((item) => !item.soldAt)
        .reduce((sum, item) => sum + Number(item.estimatedValue || 0) * Number(item.quantity || 1), 0);
      const submitted = this.collection.filter((item) => item.saleSubmissionId && !item.soldAt).length;

      this.root.innerHTML = `
        <div class="cavern-collection__shell">
          <div class="cavern-collection__tabs" role="tablist">
            ${TABS.map((tab) => `<button class="cavern-collection__tab" type="button" role="tab" aria-selected="${this.activeTab === tab}" data-tab="${tab}">${this.tabLabel(tab)}</button>`).join('')}
            <button class="cavern-collection__tab" type="button" data-action="logout">Log out</button>
          </div>
          <div class="cavern-collection__summary">
            <div class="cavern-collection__tile"><span>Estimated value</span><strong>${money(totalValue)}</strong></div>
            <div class="cavern-collection__tile"><span>Collection items</span><strong>${itemCount}</strong></div>
            <div class="cavern-collection__tile"><span>Wishlist alerts</span><strong>${this.wishlist.length}</strong></div>
          </div>
          ${submitted ? `<div class="cavern-collection__notice">You have ${submitted} item${submitted === 1 ? '' : 's'} already submitted for sell/trade review.</div>` : ''}
          ${this.renderActiveTab()}
        </div>
      `;
    }

    tabLabel(tab) {
      return {
        collection: 'My Collection',
        add: 'Add Item',
        wishlist: 'Wishlist',
        sell: 'Sell Collection',
        settings: 'Settings',
      }[tab] || tab;
    }

    renderActiveTab() {
      if (this.activeTab === 'add') return this.renderAdd();
      if (this.activeTab === 'wishlist') return this.renderWishlist();
      if (this.activeTab === 'sell') return this.renderSell();
      if (this.activeTab === 'settings') return this.renderSettings();
      return this.renderCollection();
    }

    renderCollection() {
      if (!this.collection.length) {
        return `<div class="cavern-collection__panel"><p class="cavern-collection__empty">Your collection is empty. Add your first item to start tracking value.</p></div>`;
      }

      const groups = this.collection.reduce((result, item) => {
        const key = item.consoleName || 'Other';
        result[key] = result[key] || [];
        result[key].push(item);
        return result;
      }, {});

      return `<div class="cavern-collection__panel">
        ${Object.keys(groups).sort().map((system) => `
          <h3 class="cavern-collection__section-title">${esc(system)}</h3>
          <div class="cavern-collection__list">
            ${groups[system].map((item) => (
              this.editingItemId === item.id ? this.editItemHtml(item) : this.itemHtml(item)
            )).join('')}
          </div>
        `).join('')}
      </div>`;
    }

    itemHtml(item, sellMode = false) {
      const qty = Number(item.quantity || 1);
      const value = Number(item.estimatedValue || 0);
      const isSubmitted = Boolean(item.saleSubmissionId && !item.soldAt);
      return `
        <div class="cavern-collection__item">
          ${itemImage(item) || '<div></div>'}
          <div>
            <h4>${esc(item.title)}</h4>
            <p class="cavern-collection__meta">${esc(item.consoleName)} - ${esc(item.condition || 'Game only')} - Qty ${qty} - ${money(value * qty)}</p>
            ${this.itemStateBadges(item)}
            ${item.saleSubmissionId && !item.soldAt ? '<p class="cavern-collection__meta">Submitted for review</p>' : ''}
            ${item.soldAt ? '<p class="cavern-collection__meta">Marked sold</p>' : ''}
          </div>
          <div class="cavern-collection__item-actions">
            ${sellMode ? `
              <label class="cavern-collection__checkbox-row">
                <input type="checkbox" name="selectedItemIds" value="${esc(item.id)}" data-sell-value="${esc(value * qty)}" data-sell-quantity="${esc(qty)}">
                <span>Select</span>
              </label>
            ` : isSubmitted ? `
              <button class="cavern-collection__button cavern-collection__button--secondary" type="button" data-action="sold-to-cavern" data-id="${esc(item.id)}">Sold to Cavern</button>
              <button class="cavern-collection__button cavern-collection__button--secondary" type="button" data-action="sold-elsewhere" data-id="${esc(item.id)}">Sold elsewhere</button>
              <button class="cavern-collection__button cavern-collection__button--secondary" type="button" data-action="unsubmit-item" data-id="${esc(item.id)}">Kept in collection</button>
            ` : `
              <button class="cavern-collection__button cavern-collection__button--secondary" type="button" data-action="edit-item" data-id="${esc(item.id)}">Edit</button>
              <button class="cavern-collection__button cavern-collection__button--secondary" type="button" data-action="mark-sold" data-id="${esc(item.id)}">Mark sold</button>
              <button class="cavern-collection__button cavern-collection__button--secondary" type="button" data-action="delete-item" data-id="${esc(item.id)}">Remove</button>
            `}
          </div>
        </div>
      `;
    }

    itemStateBadges(item) {
      const status = String(item?.collectionStatus || item?.needStatus || item?.state || '').toLowerCase();
      const badges = [];
      if (item?.needed || status === 'needed') badges.push('Needed');
      if (item?.missing || status === 'missing') badges.push('Missing');
      if (item?.wishlistId || status === 'wishlist') badges.push('Wishlist');
      if (!badges.length) return '';

      return `<div class="cavern-collection__badges">${badges.map((badge) => `<span>${esc(badge)}</span>`).join('')}</div>`;
    }

    editItemHtml(item) {
      return `
        <form class="cavern-collection__item cavern-collection__item--edit" data-action="save-item" data-id="${esc(item.id)}">
          ${itemImage(item) || '<div></div>'}
          <div class="cavern-collection__form">
            <h4>Edit ${esc(item.title)}</h4>
            <div class="cavern-collection__grid">
              <div class="cavern-collection__field">
                <label>Condition${this.conditionSelect(item.condition || 'Game only')}</label>
              </div>
              <div class="cavern-collection__field">
                <label>Quantity<input name="quantity" type="number" min="1" step="1" value="${esc(item.quantity || 1)}"></label>
              </div>
              <div class="cavern-collection__field">
                <label>Estimated value<input name="estimatedValue" inputmode="decimal" value="${esc(item.estimatedValue || 0)}"></label>
              </div>
              <div class="cavern-collection__field">
                <label>System<input name="consoleName" value="${esc(item.consoleName || '')}" required></label>
              </div>
            </div>
            <div class="cavern-collection__field">
              <label>Notes<textarea name="notes">${esc(item.notes || '')}</textarea></label>
            </div>
          </div>
          <div class="cavern-collection__item-actions">
            <button class="cavern-collection__button" type="submit">Save</button>
            <button class="cavern-collection__button cavern-collection__button--secondary" type="button" data-action="cancel-edit">Cancel</button>
          </div>
        </form>
      `;
    }

    renderAdd() {
      const appUrl = this.appDownloadUrl || this.resolveAppDownloadUrl('');
      return `<div class="cavern-collection__panel">
        <div class="cavern-collection__add-heading">
          <div>
            <h2>Add items in the Cavern app</h2>
            <p class="cavern-collection__help-copy">The website is for viewing your collection and sending sell/trade requests. Add games, consoles, amiibo, and wishlist items in the mobile app.</p>
          </div>
          <button class="cavern-collection__button cavern-collection__button--secondary" type="button" data-action="add-back">Back</button>
        </div>
        <div class="cavern-collection__app-prompt">
          <div class="cavern-collection__app-prompt-copy">
            <p class="cavern-collection__kicker">Mobile app</p>
            <h3>Open the app to add items</h3>
            <p>After you add or update items in the app, come back here to review your collection value or start a sell/trade request.</p>
            <div class="cavern-collection__app-actions">
              <a class="cavern-collection__button" href="${esc(appUrl)}" target="_blank" rel="noopener">Download the Cavern app</a>
              <button class="cavern-collection__button cavern-collection__button--secondary" type="button" data-tab="sell">Sell to store</button>
              <button class="cavern-collection__button cavern-collection__button--secondary" type="button" data-tab="collection">View collection</button>
            </div>
          </div>
          <a class="cavern-collection__app-qr" href="${esc(appUrl)}" target="_blank" rel="noopener" aria-label="Download the Cavern app">
            <img src="${esc(this.appDownloadQrUrl())}" alt="QR code to download the Cavern app" loading="lazy">
            <span>Scan to download</span>
          </a>
        </div>
      </div>`;
    }

    renderAddHeader() {
      return `<div class="cavern-collection__add-heading">
        <div>
          <h2>Add to collection</h2>
          <p class="cavern-collection__help-copy">${esc(this.addHeaderHelpText())}</p>
        </div>
        <button class="cavern-collection__button cavern-collection__button--secondary" type="button" data-action="add-back">Back</button>
      </div>`;
    }

    addHeaderHelpText() {
      if (this.addView === 'consoles') return 'Choose a console system, then tap a console image to add it.';
      if (this.addView === 'console-family') return 'Choose a console system, then tap a console image to add it.';
      if ((this.catalogResults || []).length) return 'Tap an image to add it to your collection.';
      return 'Search all systems by title, model, or UPC, or choose a system.';
    }

    hasAddResultsPanel() {
      return Boolean((this.catalogResults || []).length ||
        this.catalogResultsTitle ||
        this.catalogResultsHelp ||
        this.catalogResultsEmpty);
    }

    renderAddBody() {
      if (this.addView === 'consoles') return this.renderConsoleGroups();
      if (this.addView === 'console-family') return this.renderConsoleFamily();
      if (this.addView === 'section') return this.renderSectionAdd();
      return this.renderAddHome();
    }

    renderAddHome() {
      return `
        <form class="cavern-collection__add-search" data-action="catalog-search" data-scope="all">
          <div class="cavern-collection__field">
            <label for="CatalogQuery">Search all games, consoles, or UPC</label>
            <input id="CatalogQuery" name="query" inputmode="search" placeholder="Search all games, consoles, or UPC...">
          </div>
          <div class="cavern-collection__actions">
            <button class="cavern-collection__button" type="submit">Search</button>
            ${this.canScanBarcodes ? '<button class="cavern-collection__button cavern-collection__button--secondary" type="button" data-action="scan-barcode">Scan barcode</button>' : ''}
          </div>
        </form>
        ${this.renderSystemGrid()}`;
    }

    renderSectionAdd() {
      const section = this.addContext || ADD_SECTIONS[0];
      const systems = this.visibleSectionSystems(section.systems);
      return `<div>
        <p class="cavern-collection__kicker">${esc(section.label)}</p>
        <form class="cavern-collection__form" data-action="catalog-search" data-scope="section" data-section-id="${esc(section.id)}">
          <div class="cavern-collection__grid cavern-collection__grid--two">
            <div class="cavern-collection__field">
              <label for="SectionSystem">System</label>
              <select id="SectionSystem" name="system">
                <option value="">All ${esc(section.label)}</option>
                ${systems.map((system) => `<option value="${esc(system)}">${esc(system)}</option>`).join('')}
              </select>
              <p class="cavern-collection__field-help">Choose one system to browse it, or keep All ${esc(section.label)} for a wider search.</p>
            </div>
            <div class="cavern-collection__field">
              <label for="SectionCatalogQuery">Search within ${esc(section.label)}</label>
              <input id="SectionCatalogQuery" name="query" placeholder="Title, model, color, or UPC">
              <p class="cavern-collection__field-help">Type a title, model, color, or UPC. Leave this blank with a system selected to browse that system.</p>
            </div>
          </div>
          <button class="cavern-collection__button" type="submit">Search ${esc(section.label)}</button>
        </form>
      </div>`;
    }

    renderConsoleGroups() {
      const systems = this.consoleShortcutSystems();
      return `<div>
        <p class="cavern-collection__kicker">Consoles</p>
        ${systems.length ? `<div class="cavern-collection__browse-grid">
          ${systems.map((system) => this.systemTileHtml(system, {
            action: 'search-console-system',
            dataName: 'system',
            label: `${systemLabel(system)} Consoles`,
          })).join('')}
        </div>` : '<div class="cavern-collection__notice cavern-collection__notice--error">No console systems are available with the current catalog filters.</div>'}
      </div>`;
    }

    renderConsoleFamily() {
      const family = this.addContext || this.visibleConsoleFamilies()[0];
      if (!family) {
        return '<div class="cavern-collection__notice cavern-collection__notice--error">No console groups are available with the current catalog filters.</div>';
      }
      const systems = this.visibleSectionSystems(family.systems);
      return `<div>
        <p class="cavern-collection__kicker">${esc(family.label)}</p>
        <div class="cavern-collection__browse-grid">
          ${systems.map((system) => this.systemTileHtml(system, {
            action: 'search-console-system',
            dataName: 'system',
            label: `${systemLabel(system)} Consoles`,
          })).join('')}
        </div>
      </div>`;
    }

    renderSystemGrid() {
      const systems = this.filteredCatalogSystems(this.catalogSystems);
      if (!systems.length) {
        return '<div class="cavern-collection__notice">No systems match the current Catalog Settings.</div>';
      }

      const tiles = [
        this.systemShortcutTileHtml({
          label: 'All systems',
          action: 'browse-all-catalog',
          symbol: 'ALL',
        }),
        this.systemShortcutTileHtml({
          label: 'Consoles',
          action: 'show-console-groups',
          symbol: 'CON',
        }),
        ...systems.map((system) => this.systemTileHtml(system, {
          action: 'browse-catalog-system',
          dataName: 'system',
        })),
      ];
      return `<div class="cavern-collection__browse-grid">${tiles.join('')}</div>`;
    }

    systemShortcutTileHtml({ label, action, symbol }) {
      return `<button class="cavern-collection__system-card" type="button" data-action="${esc(action)}">
        <div class="cavern-collection__system-logo-well cavern-collection__system-logo-well--icon" aria-hidden="true">
          <span>${esc(symbol || systemInitials(label))}</span>
        </div>
        <strong>${esc(label)}</strong>
      </button>`;
    }

    systemTileHtml(system, { action, dataName, label = systemLabel(system) }) {
      return `<button class="cavern-collection__system-card" type="button" data-action="${esc(action)}" data-${esc(dataName)}="${esc(system)}">
        ${systemLogoHtml(system)}
        <strong>${esc(label)}</strong>
      </button>`;
    }

    addResultsHtml() {
      const results = this.catalogResults || [];
      if (!results.length && !this.catalogResultsTitle && !this.catalogResultsHelp && !this.catalogResultsEmpty) return '';
      const resultsClass = this.catalogResultsMode === 'console'
        ? 'cavern-collection__results cavern-collection__results--cards cavern-collection__results--console'
        : 'cavern-collection__results cavern-collection__results--cards';
      return `<div class="${resultsClass}">
        <div class="cavern-collection__results-heading">
          <div>
            ${this.catalogResultsTitle ? `<h3>${esc(this.catalogResultsTitle)}</h3>` : ''}
            ${this.catalogResultsHelp ? `<p class="cavern-collection__help-copy">${esc(this.catalogResultsHelp)}</p>` : ''}
          </div>
          ${this.hasAddResultsPanel() ? `<button class="cavern-collection__button cavern-collection__button--secondary" type="button" data-action="clear-add-results">Clear results</button>` : ''}
        </div>
        ${results.length
          ? results.map((game) => this.catalogResultsMode === 'console' ? this.catalogConsoleResultHtml(game) : this.catalogResultHtml(game)).join('')
          : `<div class="cavern-collection__notice">${esc(this.catalogResultsEmpty || 'No catalog matches found.')}</div>`}
      </div>`;
    }

    manualAddHtml() {
      return `
        <h3 class="cavern-collection__section-title">Unlisted item</h3>
        <p class="cavern-collection__help-copy">Use this only when catalog search cannot find the item. Unlisted items save your typed details, but may not have cover art or automatic pricing until they are matched later.</p>
        <form class="cavern-collection__form" data-action="manual-add">
          <div class="cavern-collection__grid">
            <div class="cavern-collection__field"><label>Title<input name="title" required></label></div>
            <div class="cavern-collection__field"><label>System<input name="consoleName" required></label></div>
            <div class="cavern-collection__field"><label>Condition${this.conditionSelect()}</label></div>
            <div class="cavern-collection__field"><label>Estimated value<input name="estimatedValue" inputmode="decimal" placeholder="0.00"></label></div>
          </div>
          <div class="cavern-collection__grid cavern-collection__grid--two">
            <div class="cavern-collection__field"><label>Quantity<input name="quantity" type="number" min="1" step="1" value="1"></label></div>
            <div class="cavern-collection__field"><label>UPC<input name="upc"></label></div>
            <div class="cavern-collection__field"><label>PriceCharting ID<input name="priceChartingId"></label></div>
          </div>
          <div class="cavern-collection__field"><label>Notes<textarea name="notes"></textarea></label></div>
          <button class="cavern-collection__button" type="submit">Add unlisted item</button>
        </form>`;
    }

    systemOptionHtml() {
      const systems = Array.isArray(this.catalogSystems) ? this.catalogSystems : FALLBACK_CATALOG_SYSTEMS;
      return this.filteredCatalogSystems(systems)
        .map((system) => `<option value="${esc(system)}"></option>`)
        .join('');
    }

    visibleSectionSystems(systems) {
      const available = normalizedSystemSet(this.catalogSystems);
      return (Array.isArray(systems) ? systems : [])
        .filter((system) => !available.size || available.has(normalizeCatalogSystem(system)))
        .filter((system) => this.allowsCatalogSystem(system));
    }

    visibleAddSections() {
      return ADD_SECTIONS
        .map((section) => ({
          ...section,
          systems: this.visibleSectionSystems(section.systems),
        }))
        .filter((section) => section.systems.length);
    }

    visibleConsoleFamilies() {
      return CONSOLE_FAMILIES
        .map((family) => ({
          ...family,
          systems: this.visibleSectionSystems(family.systems),
        }))
        .filter((family) => family.systems.length);
    }

    addSectionById(id) {
      return ADD_SECTIONS.find((section) => section.id === id);
    }

    consoleFamilyById(id) {
      return this.visibleConsoleFamilies().find((family) => family.id === id);
    }

    filteredCatalogSystems(systems) {
      return (Array.isArray(systems) ? systems : [])
        .filter((system) => system && normalizeCatalogSystem(system) !== 'all')
        .filter((system) => this.allowsCatalogSystem(system));
    }

    allowsCatalogSystem(system) {
      const settings = {
        ...DEFAULT_CATALOG_FILTER_SETTINGS,
        ...(this.catalogFilterSettings || {}),
      };
      return catalogSettingsAllowSystem(settings, system);
    }

    filterCatalogItems(items) {
      return (Array.isArray(items) ? items : [])
        .filter((item) => this.allowsCatalogSystem(catalogSystemForItem(item)));
    }

    async ensureConsoleVariationCatalog() {
      if (this.consoleVariationCatalog.length) return this.consoleVariationCatalog;
      if (this.consoleVariationCatalogLoad) return await this.consoleVariationCatalogLoad;

      this.consoleVariationCatalogLoad = fetch(CONSOLE_VARIATIONS_SEARCH_INDEX_URL, { cache: 'force-cache' })
        .then((response) => {
          if (!response.ok) throw new Error(`ConsoleVariations returned ${response.status}`);
          return response.json();
        })
        .then((decoded) => {
          const result = consoleVariationGamesFromJson(decoded);
          this.consoleVariationCatalog = result.games;
          this.consoleVariationRegionsById = result.regionsById;
          return this.consoleVariationCatalog;
        })
        .catch(() => {
          this.consoleVariationCatalog = [];
          this.consoleVariationRegionsById = {};
          return [];
        })
        .finally(() => {
          this.consoleVariationCatalogLoad = null;
        });

      return await this.consoleVariationCatalogLoad;
    }

    filteredConsoleVariationCatalog() {
      const settings = {
        ...DEFAULT_CATALOG_FILTER_SETTINGS,
        ...(this.catalogFilterSettings || {}),
      };

      return this.consoleVariationCatalog.filter((game) => {
        if (!catalogSettingsAllowSystem(settings, catalogSystemForItem(game))) return false;
        if (settings.includeImports) return true;
        return consoleVariationRegionIsAmerican(
          this.consoleVariationRegionsById[game.id],
          catalogTitle(game)
        );
      });
    }

    consoleRowsForSearch({ catalogItems = [], system = '', query = '' } = {}) {
      const settings = {
        ...DEFAULT_CATALOG_FILTER_SETTINGS,
        ...(this.catalogFilterSettings || {}),
      };
      const normalizedQuery = normalizeCatalogSystem(query);
      const rows = [];
      const seen = new Set();
      const seenTitleSystems = new Set();
      const hasSystem = String(system || '').trim() !== '';

      const addRow = (game) => {
        const title = catalogTitle(game);
        const rowSystem = catalogSystemForItem(game);
        if (!title || !rowSystem) return;
        const key = this.catalogResultKey(game);
        const titleSystemKey = `${normalizeCatalogSystem(title)}|${normalizeCatalogSystem(rowSystem)}`;
        if (seen.has(key) || seenTitleSystems.has(titleSystemKey)) return;
        seen.add(key);
        seenTitleSystems.add(titleSystemKey);
        rows.push(game);
      };

      const matchesSystem = (gameOrSystem) => {
        if (!hasSystem) return true;
        return systemsOverlap(
          typeof gameOrSystem === 'string' ? gameOrSystem : catalogSystemForItem(gameOrSystem),
          system
        );
      };
      const matchesQuery = (game) => catalogGameMatchesSearch(game, normalizedQuery);
      const catalogPriceSources = this.filterCatalogItems(catalogItems);
      const backendConsoleRows = catalogPriceSources
        .filter(isConsoleCatalogItem)
        .filter(matchesSystem)
        .filter(matchesQuery);

      this.filteredConsoleVariationCatalog()
        .filter(matchesSystem)
        .filter(matchesQuery)
        .map((game) => catalogGameWithBestPrice(game, catalogPriceSources, settings))
        .forEach(addRow);

      FALLBACK_CONSOLE_VARIANTS
        .filter((variant) => fallbackConsoleVariantAllowed(variant, settings))
        .filter((variant) => matchesSystem(variant.system))
        .map(fallbackConsoleVariantGame)
        .filter(matchesQuery)
        .map((game) => catalogGameWithBestPrice(game, catalogPriceSources, settings))
        .forEach(addRow);

      backendConsoleRows.forEach(addRow);

      if (hasSystem && !rows.length && catalogSettingsAllowSystem(settings, system)) {
        addRow(syntheticConsoleCatalogGame(system));
      }

      return rows.sort(compareConsoleCatalogRows);
    }

    conditionSelect(selected = 'Game only', conditions = null) {
      const choices = conditions || [
        'Game only',
        'Complete',
        'New / sealed',
        'With case - no manual',
        'Manual only',
        'Box only',
        'Amiibo only',
        'Figure only',
        'Magazine only',
        'Complete with inserts',
        'Poster/inserts only'
      ];
      const selectedCondition = selected === 'New/sealed' ? 'New / sealed' : selected;
      const choiceList = choices.includes(selectedCondition) ? choices : [selectedCondition, ...choices];
      return `<select name="condition">${choiceList.map((condition) => `<option value="${esc(condition)}"${condition === selectedCondition ? ' selected' : ''}>${esc(condition)}</option>`).join('')}</select>`;
    }

    catalogResultHtml(game) {
      return this.catalogCardHtml(game);
    }

    catalogConsoleResultHtml(game) {
      return this.catalogCardHtml(game, true);
    }

    catalogCardHtml(game, consoleCard = false) {
      const resultKey = this.catalogResultKey(game);
      const defaultCondition = this.defaultConditionForGame(game);
      const defaultValue = conditionValue(game, defaultCondition);
      const valueAttr = defaultValue > 0 ? defaultValue.toFixed(2) : '';
      const cardClass = consoleCard
        ? 'cavern-collection__catalog-card cavern-collection__catalog-card--console'
        : 'cavern-collection__catalog-card';
      return `<form class="${cardClass}" data-action="add-catalog-form" data-id="${esc(resultKey)}">
        <button class="cavern-collection__catalog-card-main" type="submit">
          <span class="cavern-collection__catalog-card-image">
            ${catalogImageHtml(game)}
          </span>
          <span class="cavern-collection__catalog-card-body">
            <strong>${esc(game.title || game.name)}</strong>
            <span>${esc(catalogSystemForItem(game))}</span>
          </span>
        </button>
        <input type="hidden" name="condition" value="${esc(defaultCondition)}">
        <input type="hidden" name="quantity" value="1">
        <input type="hidden" name="estimatedValue" value="${esc(valueAttr)}">
        <textarea name="notes" hidden></textarea>
        <div class="cavern-collection__catalog-card-actions">
          <button class="cavern-collection__button" type="submit">Add to collection</button>
          <button class="cavern-collection__button cavern-collection__button--secondary" type="button" data-action="wishlist-catalog" data-id="${esc(resultKey)}">Add to wishlist</button>
        </div>
      </form>`;
    }

    priceSummaryHtml(game) {
      if (!hasCatalogPrice(game)) {
        return '<p class="cavern-collection__meta cavern-collection__meta--warning">Pricing unavailable</p>';
      }

      const prices = [
        ['Loose', game.looseValue || game.loosePrice],
        ['Complete', game.completeValue || game.completePrice || game.cibPrice],
        ['New', game.newValue || game.newPrice],
        ['Box', game.boxOnlyValue || game.boxOnlyPrice],
        ['Manual', game.manualOnlyValue || game.manualOnlyPrice],
      ]
        .filter(([, value]) => Number(value || 0) > 0)
        .map(([label, value]) => `${label} ${money(value)}`);

      return `<p class="cavern-collection__meta">${esc(prices.join(' - '))}</p>`;
    }

    defaultConditionForGame(game) {
      const identity = this.catalogIdentity(game);
      if (identity.includes('amiibo') || identity.includes('amibo')) return 'Amiibo only';
      if (identity.includes('figure')) return 'Figure only';
      if (identity.includes('magazine')) return 'Magazine only';
      if (isConsoleCatalogItem(game)) return 'Console only';
      if (this.catalogUsesDiscLooseLabel(game)) return 'Disc only';
      if (this.catalogUsesCartLooseLabel(game)) return 'Cart only';
      return 'Game only';
    }

    conditionOptionsForGame(game) {
      const identity = this.catalogIdentity(game);
      if (identity.includes('amiibo') || identity.includes('amibo')) {
        return ['Amiibo only', 'New / sealed', 'Box only', WISHLIST_CONDITION];
      }
      if (identity.includes('figure')) {
        return ['Figure only', 'New / sealed', 'Box only', WISHLIST_CONDITION];
      }
      if (identity.includes('magazine')) {
        return ['Magazine only', 'Complete with inserts', 'New / sealed', 'Poster/inserts only', WISHLIST_CONDITION];
      }
      if (isConsoleCatalogItem(game)) {
        return ['Console only', 'Complete', 'New / sealed', 'Box only', 'Manual only', WISHLIST_CONDITION];
      }
      return [this.defaultConditionForGame(game), 'Complete', 'New / sealed', 'With case - no manual', 'Manual only', 'Box only', WISHLIST_CONDITION];
    }

    catalogUsesDiscLooseLabel(game) {
      const system = normalizeCatalogSystem(catalogSystemForItem(game));
      return [
        'playstation',
        'playstation 2',
        'playstation 3',
        'playstation 4',
        'playstation 5',
        'psp',
        'playstation vita',
        'xbox',
        'xbox 360',
        'xbox one',
        'xbox series x',
        'gamecube',
        'wii',
        'wii u',
        'sega cd',
        'sega saturn',
        'sega dreamcast',
        '3do',
        'jaguar cd',
      ].includes(system);
    }

    catalogUsesCartLooseLabel(game) {
      const system = normalizeCatalogSystem(catalogSystemForItem(game));
      return [
        'nes',
        'super nintendo',
        'nintendo 64',
        'nintendo switch',
        'nintendo switch 2',
        'gameboy',
        'gameboy color',
        'gameboy advance',
        'nintendo ds',
        'nintendo 3ds',
        'sega genesis',
        'sega master system',
        'sega 32x',
        'sega game gear',
        'atari 2600',
        'atari 5200',
        'atari 7800',
        'atari lynx',
        'colecovision',
        'intellivision',
        'jaguar',
        'virtual boy',
      ].includes(system);
    }

    catalogIdentity(game) {
      return [
        game.consoleName,
        game.console,
        game.platform,
        game.system,
        game.itemType,
        game.type,
        game.title,
        game.name,
      ].map((value) => String(value || '').toLowerCase()).join(' ');
    }

    renderWishlist() {
      return `<div class="cavern-collection__panel">
        <h2>Wishlist alerts</h2>
        <form class="cavern-collection__form" data-action="wishlist-manual">
          <div class="cavern-collection__grid">
            <div class="cavern-collection__field"><label>Title<input name="title" required></label></div>
            <div class="cavern-collection__field"><label>System<input name="consoleName"></label></div>
            <div class="cavern-collection__field"><label>Desired condition<input name="desiredCondition" value="Any"></label></div>
            <div class="cavern-collection__field"><label>Target price<input name="targetPrice" inputmode="decimal"></label></div>
          </div>
          <button class="cavern-collection__button" type="submit">Add wishlist alert</button>
        </form>
        <div class="cavern-collection__list" style="margin-top:1.6rem;">
          ${this.wishlist.length ? this.wishlist.map((item) => this.wishlistHtml(item)).join('') : '<p class="cavern-collection__empty">No wishlist items yet.</p>'}
        </div>
      </div>`;
    }

    wishlistHtml(item) {
      return `<div class="cavern-collection__item">
        ${itemImage(item) || '<div></div>'}
        <div>
          <h4>${esc(item.title)}</h4>
          <p class="cavern-collection__meta">${esc(item.consoleName || 'Any system')} - ${esc(this.notifyLabel(item))}</p>
        </div>
        <div class="cavern-collection__item-actions">
          <button class="cavern-collection__button cavern-collection__button--secondary" type="button" data-action="delete-wishlist" data-id="${esc(item.id)}">Remove</button>
        </div>
      </div>`;
    }

    notifyLabel(item) {
      const status = item.notifyStatus || '';
      if (!item.notifyWhenInStock) return 'No stock alert';
      if (status === 'watching') return 'Watching stock';
      if (status === 'in_stock') return 'In stock now';
      if (status === 'no_match') return 'Alert match pending';
      if (status === 'needs_email') return 'Verify email for alerts';
      if (status === 'sync_failed') return 'Alert sync retry later';
      return 'Notify in stock';
    }

    renderSell() {
      const sellable = this.collection.filter((item) => !item.soldAt && !item.saleSubmissionId);
      return `<div class="cavern-collection__panel">
        <h2>Sell My Collection</h2>
        <div class="cavern-collection__notice">
          Your collection is private. The store cannot view it unless you choose to submit selected items for a sell/trade estimate. Nothing is shared with the store until you submit selected items.
        </div>
        ${sellable.length ? `
          <form class="cavern-collection__form" data-action="sell-submit">
            ${this.sellEstimateSummaryHtml()}
            ${this.tradeMethodHtml()}
            <div class="cavern-collection__list">${sellable.map((item) => this.itemHtml(item, true)).join('')}</div>
            <div class="cavern-collection__field"><label>Note optional<textarea name="note" rows="3"></textarea></label></div>
            ${this.sellTermsHtml()}
            <button class="cavern-collection__button" type="submit" data-sell-submit>Submit selected items for store review</button>
          </form>
        ` : '<p class="cavern-collection__empty">No sellable items are available right now.</p>'}
      </div>`;
    }

    sellEstimateSummaryHtml() {
      return `<div class="cavern-collection__sell-summary">
        <h3 data-sell-count>0 copies selected</h3>
        <div class="cavern-collection__sell-estimates">
          <div><strong data-sell-retail>${money(0)}</strong><span>Estimated retail value</span></div>
          <div><strong data-sell-range>${money(0)} - ${money(0)}</strong><span>Estimated offer range</span></div>
        </div>
        <p class="cavern-collection__help-copy">Estimate only. Final offers are subject to store review and may change based on condition, completeness, authenticity, demand, and current resale value.</p>
      </div>`;
    }

    tradeMethodHtml() {
      return `<fieldset class="cavern-collection__trade-method">
        <legend>How will you trade?</legend>
        <label>
          <input type="radio" name="tradeMethod" value="bring_in" checked>
          <span><strong>Bring to Store</strong><small>I will bring it in</small></span>
        </label>
        <label>
          <input type="radio" name="tradeMethod" value="mail_in">
          <span><strong>Mail In</strong><small>I will ship it</small></span>
        </label>
      </fieldset>`;
    }

    sellTermsHtml() {
      const terms = [
        'Submitting this form sends only the selected items to The Video Game Cavern for review.',
        'The estimate shown is not a final offer. Final offers depend on verified condition, completeness, authenticity, demand, and store inspection.',
        'The Video Game Cavern may provide a prepaid shipping label for approved mail-in trades. This label is for shipping the selected items to us for review.',
        'Payment is issued only after the items are received, inspected, tested, and the final offer is accepted.',
        'Final payouts may be sent through approved digital payment methods such as Zelle, Cash App, or Venmo.',
        'If any items are declined, ineligible, damaged, counterfeit, account locked, modified, or not as described, those items may not be accepted.',
        'If you decline the final offer on a mail-in trade, you are responsible for return shipping.',
        'If any mail-in items are declined, ineligible, damaged, counterfeit, account locked, modified, or not as described, you are responsible for return shipping for those items.',
        'Return shipping may be deducted from the final payout or paid before items are returned.',
        'Consoles and accessories must be authentic, functional, unmodified, not account locked, and in original condition unless clearly noted.',
        'The Video Game Cavern must test, clean, recondition, format, and prepare items for resale, so trade offers are below full retail value.',
        'The store may decline items or adjust the final offer after review.',
      ];
      const restrictedItems = [
        'Steering wheels, racing pedals, or large specialty controllers',
        'VR headsets or VR accessories',
        'Headphones, earbuds, or used headsets',
        'Modified, repaired, opened, or altered consoles',
        'Account-locked consoles or devices',
        'PC games, PC hardware, or computer accessories',
        'Third-party charging docks, cables, power bricks, or generic accessories unless specifically requested',
        'Items with smoke, pests, liquid, mold, or heavy odor damage',
        'Damaged, counterfeit, incomplete, or non-working items unless clearly disclosed and approved before review or shipping',
      ];

      return `<div class="cavern-collection__terms">
        <h3>Terms and conditions</h3>
        ${this.termListHtml(terms)}
        <h4>Important trade restrictions</h4>
        <p class="cavern-collection__help-copy">Please bring or send only the items that were selected and approved in this submission. Do not include extra games, accessories, consoles, or equipment that were not listed on this form.</p>
        <p class="cavern-collection__help-copy">We do not accept the following items:</p>
        ${this.termListHtml(restrictedItems)}
        <p class="cavern-collection__help-copy">Any unapproved, declined, or ineligible items may reduce the final offer, may not be accepted, and for mail-in trades may require return shipping at the customer's expense.</p>
        <label class="cavern-collection__checkbox-row">
          <input type="checkbox" name="termsAccepted" required>
          <span>I understand this is an estimate only. I agree to submit only the selected items listed in this submission, and I understand that unapproved, declined, or ineligible items may not be accepted. For mail-in trades, I understand I am responsible for return shipping if I decline the final offer or if any items cannot be accepted.</span>
        </label>
      </div>`;
    }

    termListHtml(items) {
      return `<ul class="cavern-collection__terms-list">
        ${items.map((item) => `<li>${esc(item)}</li>`).join('')}
      </ul>`;
    }

    renderSettings() {
      const settings = {
        ...DEFAULT_CATALOG_FILTER_SETTINGS,
        ...(this.catalogFilterSettings || {}),
      };

      return `<div class="cavern-collection__panel">
        <h2>Catalog Settings</h2>
        <p class="cavern-collection__help-copy">Default catalog: U.S. home and handheld consoles, magazines, Amiibo, Skylanders, and Disney Infinity.</p>
        <form class="cavern-collection__form" data-action="save-catalog-settings">
          <div class="cavern-collection__settings-list">
            ${this.settingsCheckboxHtml(
              'includeImports',
              settings.includeImports,
              'Include imports',
              'JP and Asian English systems'
            )}
            ${this.settingsCheckboxHtml(
              'includeComputers',
              settings.includeComputers,
              'Include computers',
              'Amiga, Apple, Commodore, MSX'
            )}
            ${this.settingsCheckboxHtml(
              'includeMagazines',
              settings.includeMagazines,
              'Include magazines',
              'Nintendo Power, EGM, GamePro, Game Informer'
            )}
          </div>
          <p class="cavern-collection__help-copy">Turn magazines off here if you only want games and figures in My Collection search.</p>
          <button class="cavern-collection__button" type="submit">Save settings</button>
        </form>
        <div class="cavern-collection__settings-footer">
          <h3>Privacy</h3>
          <p class="cavern-collection__help-copy">Log out to hide My Collection and Rewards on this browser. Your saved collection stays safe online.</p>
          <div class="cavern-collection__actions">
            <button class="cavern-collection__button cavern-collection__button--secondary" type="button" data-action="logout">Log out on this browser</button>
            <button class="cavern-collection__button" type="button" data-action="settings-done">Done</button>
          </div>
        </div>
      </div>`;
    }

    settingsCheckboxHtml(name, checked, title, subtitle) {
      return `<label class="cavern-collection__settings-row">
        <input type="checkbox" name="${esc(name)}"${checked ? ' checked' : ''}>
        <span>
          <strong>${esc(title)}</strong>
          <small>${esc(subtitle)}</small>
        </span>
      </label>`;
    }

    async bootstrapSession() {
      if (this.token) {
        try {
          await this.request('/api/auth/session-cookie', { method: 'POST' });
        } catch (_) {
          // Invalid old browser tokens will fall through to the normal sign-in screen.
        } finally {
          this.token = '';
          localStorage.removeItem(TOKEN_KEY);
        }
      }

      await this.loadAll();
    }

    async loadAll() {
      this.setBusy(true, 'Loading your collection...');
      this.setStatus('Loading your collection...');
      try {
        const [collection, wishlist] = await Promise.all([
          this.request('/api/collection'),
          this.request('/api/wishlist'),
        ]);
        this.collection = Array.isArray(collection.items) ? collection.items : [];
        this.wishlist = Array.isArray(wishlist.items) ? wishlist.items : [];
        this.setStatus('');
        this.renderApp();
      } catch (error) {
        if (error.status === 401) {
          this.setStatus('');
          this.renderAuth();
          return;
        }
        this.setStatus(error.message, true);
        if (!this.token) this.renderAuth();
      } finally {
        this.setBusy(false);
      }
    }

    async loadCatalogSystems() {
      try {
        const result = await this.request('/api/catalog/systems');
        const systems = Array.isArray(result.systems)
          ? result.systems.filter((system) => system && system !== 'All')
          : [];

        if (systems.length) {
          this.catalogSystems = systems;
          this.catalogSystemsError = '';
          if (this.activeTab === 'add') this.renderApp();
        }
      } catch (error) {
        this.catalogSystemsError = `Catalog systems could not load: ${error.message}`;
        if (this.activeTab === 'add') this.renderApp();
      }
    }

    async handleSubmit(event) {
      const form = event.target.closest('form[data-action]');
      if (!form) return;
      event.preventDefault();
      if (this.busy) {
        event.stopPropagation();
        return;
      }
      const action = form.dataset.action;
      const data = new FormData(form);

      try {
        this.setBusy(true, this.submitBusyMessage(action));
        this.setStatus('');
        if (action === 'request-code') return await this.requestCode(data);
        if (action === 'verify-code') return await this.verifyCode(data);
        if (action === 'account-help') return await this.accountHelp(data);
        if (action === 'catalog-search') return await this.catalogSearch(form, data);
        if (action === 'upc-search') return await this.upcSearch(data);
        if (action === 'add-catalog-form') return await this.addCatalogForm(form, data);
        if (action === 'manual-add') return await this.manualAdd(data);
        if (action === 'save-item') return await this.saveItem(form, data);
        if (action === 'wishlist-manual') return await this.wishlistManual(data);
        if (action === 'sell-submit') return await this.sellSubmit(form, data);
        if (action === 'save-catalog-settings') return this.saveCatalogSettings(data);
      } catch (error) {
        this.setStatus(error.message, true);
      } finally {
        this.setBusy(false);
      }
    }

    async handleClick(event) {
      if (this.busy) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      const tab = event.target.closest('[data-tab]');
      if (tab) {
        const nextTab = tab.dataset.tab;
        this.activeTab = nextTab;
        if (nextTab === 'add') this.resetAddFlow(false);
        this.renderApp();
        return;
      }

      const button = event.target.closest('[data-action]');
      if (!button) return;
      const action = button.dataset.action;
      if (button.closest('form') && action !== 'wishlist-catalog') return;

      const busyMessage = this.clickBusyMessage(action, button);
      try {
        if (busyMessage) this.setBusy(true, busyMessage);
        this.setStatus('');
        if (action === 'show-help') return this.renderAuth(true);
        if (action === 'back-login') return this.renderAuth();
        if (action === 'logout') return this.logout();
        if (action === 'settings-done') return this.closeSettings();
        if (action === 'toggle-manual-add') return this.toggleManualAdd();
        if (action === 'select-add-section') return this.selectAddSection(button.dataset.section);
        if (action === 'show-console-groups') return this.showConsoleGroups();
        if (action === 'browse-all-catalog') return await this.browseAllCatalog();
        if (action === 'open-console-family') return this.openConsoleFamily(button.dataset.family);
        if (action === 'browse-catalog-system') return await this.browseCatalogSystem(button.dataset.system);
        if (action === 'search-console-system') return await this.searchConsoleSystem(button.dataset.system);
        if (action === 'add-back') return this.handleAddBack();
        if (action === 'clear-add-results') return this.clearAddResults();
        if (action === 'scan-barcode') return await this.scanBarcode();
        if (action === 'wishlist-catalog') return await this.wishlistCatalog(button.dataset.id);
        if (action === 'edit-item') return this.editItem(button.dataset.id);
        if (action === 'cancel-edit') return this.cancelEdit();
        if (action === 'delete-item') return await this.deleteItem(button.dataset.id);
        if (action === 'mark-sold') return await this.markSold(button.dataset.id);
        if (action === 'sold-to-cavern') return await this.markSold(button.dataset.id, 'The Video Game Cavern');
        if (action === 'sold-elsewhere') return await this.markSold(button.dataset.id, 'Sold elsewhere');
        if (action === 'unsubmit-item') return await this.unsubmitItem(button.dataset.id);
        if (action === 'delete-wishlist') return await this.deleteWishlist(button.dataset.id);
      } catch (error) {
        this.setStatus(error.message, true);
      } finally {
        if (busyMessage) this.setBusy(false);
      }
    }

    handleChange(event) {
      const sellInput = event.target.closest('input[name="selectedItemIds"], input[name="tradeMethod"]');
      if (sellInput) {
        this.updateSellEstimateSummary(sellInput.closest('form[data-action="sell-submit"]'));
        return;
      }

      const condition = event.target.closest('select[name="condition"]');
      if (!condition) return;

      const addForm = condition.closest('form[data-action="add-catalog-form"]');
      if (addForm) {
        const game = this.catalogById(addForm.dataset.id);
        const valueInput = addForm.querySelector('input[name="estimatedValue"]');
        if (!game || !valueInput) return;

        const nextValue = conditionValue(game, condition.value);
        valueInput.value = nextValue > 0 ? nextValue.toFixed(2) : '';
        return;
      }

      const editForm = condition.closest('form[data-action="save-item"]');
      if (editForm) {
        this.updateEditValueForCondition(editForm, condition.value);
      }
    }

    updateSellEstimateSummary(form) {
      if (!form) return;
      const selectedItems = Array.from(form.querySelectorAll('input[name="selectedItemIds"]:checked'));
      const selected = selectedItems.reduce((result, input) => ({
        count: result.count + Number(input.dataset.sellQuantity || 1),
        retailValue: result.retailValue + Number(input.dataset.sellValue || 0),
      }), { count: 0, retailValue: 0 });
      const method = form.querySelector('input[name="tradeMethod"]:checked')?.value || 'bring_in';
      const count = form.querySelector('[data-sell-count]');
      const retail = form.querySelector('[data-sell-retail]');
      const range = form.querySelector('[data-sell-range]');
      const submit = form.querySelector('[data-sell-submit]');

      if (count) count.textContent = selected.count === 1 ? '1 copy selected' : `${selected.count} copies selected`;
      if (retail) retail.textContent = money(selected.retailValue);
      if (range) range.textContent = `${money(selected.retailValue * 0.30)} - ${money(selected.retailValue * 0.55)}`;
      if (submit) {
        submit.textContent = method === 'mail_in'
          ? 'Submit selected items for mail-in review'
          : 'Submit selected items for store review';
      }
    }

    async requestCode(data) {
      const email = String(data.get('email') || '').trim().toLowerCase();
      if (!looksLikeEmail(email)) throw new Error('Enter a valid email address.');
      await this.request('/api/auth/generate-code', {
        method: 'POST',
        body: JSON.stringify({ email }),
      });
      this.email = email;
      localStorage.setItem(EMAIL_KEY, email);
      this.renderCodeForm(email);
      this.setStatus('Verification code sent.');
    }

    async verifyCode(data) {
      const email = String(data.get('email') || '').trim().toLowerCase();
      const code = String(data.get('code') || '').trim();
      const result = await this.request('/api/auth/verify-code', {
        method: 'POST',
        body: JSON.stringify({ email, code }),
      });
      if (!result.customerFound) {
        this.email = email;
        this.renderAuth(true);
        throw new Error('We could not find a Cavern customer account with that email. You can create a new account or request help finding an older account.');
      }
      this.token = '';
      this.email = email;
      localStorage.removeItem(TOKEN_KEY);
      localStorage.setItem(EMAIL_KEY, email);
      await this.loadAll();
    }

    async accountHelp(data) {
      const payload = {
        name: String(data.get('name') || '').trim(),
        phone: String(data.get('phone') || '').trim(),
        email: String(data.get('email') || '').trim().toLowerCase(),
        note: String(data.get('note') || '').trim(),
        accepted: data.get('accepted') === 'on',
      };
      await this.request('/api/auth/account-help', {
        method: 'POST',
        body: JSON.stringify(payload),
      });
      this.renderAuth();
      this.setStatus('Account help request sent. Please allow up to 48 hours for review.');
    }

    saveCatalogSettings(data) {
      this.catalogFilterSettings = {
        includeImports: data.get('includeImports') === 'on',
        includeComputers: data.get('includeComputers') === 'on',
        includeMagazines: data.get('includeMagazines') === 'on',
      };
      localStorage.setItem(CATALOG_FILTER_KEY, JSON.stringify(this.catalogFilterSettings));
      this.catalogResults = this.filterCatalogItems(this.catalogResults);
      this.renderApp();
      this.setStatus('Catalog settings saved.');
    }

    closeSettings() {
      this.activeTab = 'collection';
      this.renderApp();
    }

    resetAddFlow(render = true) {
      this.addView = 'home';
      this.addContext = null;
      this.manualAddOpen = false;
      this.clearAddResults(false);
      if (render) this.renderApp();
    }

    selectAddSection(sectionId) {
      const section = this.addSectionById(sectionId);
      if (!section) return;
      this.addView = 'section';
      this.addContext = section;
      this.clearAddResults(false);
      this.renderApp();
    }

    showConsoleGroups() {
      this.addView = 'consoles';
      this.addContext = null;
      this.clearAddResults(false);
      this.renderApp();
    }

    openConsoleFamily(familyId) {
      const family = this.consoleFamilyById(familyId);
      if (!family) return;
      this.addView = 'console-family';
      this.addContext = family;
      this.clearAddResults(false);
      this.renderApp();
    }

    async browseAllCatalog() {
      this.addView = 'home';
      this.addContext = null;
      this.setStatus('Loading all systems...');
      const result = await this.fetchCatalogItems({
        limit: 360,
      });

      this.setCatalogResults(result.items, {
        title: 'All systems',
        help: result.items.length ? 'Tap an image to add it to your collection.' : '',
        empty: 'No catalog matches found.',
        mode: 'catalog',
      });
      this.renderApp();
      this.setStatus('');
    }

    async browseCatalogSystem(system) {
      const normalizedSystem = this.catalogSystemForSearch(system);
      if (!normalizedSystem || !this.allowsCatalogSystem(normalizedSystem)) {
        throw new Error('That system is hidden by Catalog Settings. Turn it on in Settings to browse it.');
      }

      this.addView = 'home';
      this.addContext = null;
      this.setStatus(`Loading ${normalizedSystem}...`);
      const result = await this.fetchCatalogItems({
        system: normalizedSystem,
        limit: 360,
      });

      this.setCatalogResults(result.items, {
        title: normalizedSystem,
        help: result.items.length ? 'Tap an image to add it to your collection.' : '',
        empty: `No catalog matches found for ${normalizedSystem}.`,
        mode: 'catalog',
      });
      this.renderApp();
      this.setStatus('');
    }

    async searchConsoleSystem(system) {
      const normalizedSystem = this.catalogSystemForSearch(system);
      if (!normalizedSystem || !this.allowsCatalogSystem(normalizedSystem)) {
        throw new Error('That system is hidden by Catalog Settings. Turn it on in Settings to search it.');
      }

      this.setStatus(`Loading ${normalizedSystem} console variants...`);
      await this.ensureConsoleVariationCatalog();
      const result = await this.fetchCatalogItems({
        query: consoleRemoteSearchQuery(normalizedSystem),
        limit: 360,
      });
      const consoleItems = this.consoleRowsForSearch({
        catalogItems: result.items,
        system: normalizedSystem,
        query: normalizedSystem,
      });

      this.setCatalogResults(consoleItems, {
        title: `${normalizedSystem} console variants`,
        help: consoleItems.length
          ? 'Tap the console image to add it to your collection.'
          : 'No console hardware rows came back for this system yet.',
        mode: 'console',
        empty: `No console variants found for ${normalizedSystem}. Try the regular catalog search by model or color, or use Add unlisted item if the console is not in the catalog yet.`,
      });
      this.renderApp();
      this.setStatus('');
    }

    handleAddBack() {
      if (this.hasAddResultsPanel()) {
        this.clearAddResults();
        return;
      }
      if (this.addView === 'console-family') {
        this.addView = 'consoles';
        this.addContext = null;
        this.clearAddResults(false);
        this.renderApp();
        return;
      }
      if (this.addView === 'consoles' || this.addView === 'section') {
        this.addView = 'home';
        this.addContext = null;
        this.clearAddResults(false);
        this.renderApp();
        return;
      }
      this.activeTab = 'collection';
      this.renderApp();
    }

    clearAddResults(render = true) {
      this.catalogResults = [];
      this.catalogResultsTitle = '';
      this.catalogResultsHelp = '';
      this.catalogResultsEmpty = '';
      this.catalogResultsMode = 'catalog';
      if (render) this.renderApp();
    }

    async scanBarcode() {
      if (!this.canScanBarcodes) {
        throw new Error('Barcode scanning is not supported in this browser. You can type the UPC instead.');
      }

      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
      input.capture = 'environment';
      const file = await new Promise((resolve) => {
        input.addEventListener('change', () => resolve(input.files?.[0] || null), { once: true });
        input.click();
      });
      if (!file) return;

      const detector = new window.BarcodeDetector({
        formats: ['ean_13', 'ean_8', 'upc_a', 'upc_e', 'code_128'],
      });
      const bitmap = await createImageBitmap(file);
      const codes = await detector.detect(bitmap);
      const rawValue = codes.find((code) => code.rawValue)?.rawValue || '';
      const upc = String(rawValue).replace(/\D/g, '');
      if (!upc) throw new Error('No barcode was found in that image.');
      await this.lookupUpc(upc);
    }

    async catalogSearch(form, data) {
      const query = String(data.get('query') || '').trim();
      const system = this.catalogSystemForSearch(data.get('system'));
      const scope = form?.dataset?.scope || 'all';
      const section = scope === 'section' ? this.addSectionById(form.dataset.sectionId) : null;
      const sectionSystems = section ? this.visibleSectionSystems(section.systems) : [];
      const upcMode = isLikelyUpc(query);

      if (!query && !system) {
        throw new Error(section ? 'Enter a search term or choose a specific system to browse.' : 'Enter a game title/UPC or choose a system.');
      }
      if (!upcMode && system && !this.allowsCatalogSystem(system)) {
        throw new Error('That system is hidden by Catalog Settings. Turn it on in Settings to search it.');
      }

      const result = await this.fetchCatalogItems({
        query,
        system: upcMode ? '' : system,
        limit: upcMode ? 48 : 360,
      });
      let items = result.items;
      let consoleRows = [];
      if (!upcMode && query) {
        await this.ensureConsoleVariationCatalog();
        consoleRows = this.consoleRowsForSearch({
          catalogItems: result.items,
          system,
          query,
        });
        if (section && !system) {
          consoleRows = this.filterItemsToSystems(consoleRows, sectionSystems);
        }
      }
      if (section && !system && !upcMode) {
        items = this.filterItemsToSystems(items, sectionSystems);
      }
      if (section && system) {
        items = this.filterItemsToSystems(items, [system]);
      }
      if (consoleRows.length) {
        items = [...items, ...consoleRows];
      }

      this.setCatalogResults(items, {
        title: upcMode ? `UPC matches for ${query.replace(/\D/g, '')}` : section ? `${section.label} matches` : 'Catalog matches',
        help: upcMode
          ? 'Choose the exact title and system. Shared UPCs are not merged automatically.'
          : 'Tap an image or Add to collection, or use Add to wishlist if you do not own it yet.',
        empty: result.items.length || consoleRows.length ? 'Matches were hidden by Catalog Settings.' : 'No catalog matches found.',
        mode: upcMode ? 'upc' : 'catalog',
      });
      this.renderApp();
      this.setStatus('');
    }

    async upcSearch(data) {
      const upc = String(data.get('upc') || '').trim().replace(/\D/g, '');
      await this.lookupUpc(upc);
    }

    async lookupUpc(upc) {
      if (!isLikelyUpc(upc)) throw new Error('Enter an 8 to 14 digit UPC or barcode.');
      const result = await this.fetchCatalogItems({ query: upc, limit: 48 });
      this.setCatalogResults(result.items, {
        title: `UPC matches for ${upc}`,
        help: result.items.length
          ? 'Tap an image or Add to collection for the exact title and system, or use Add to wishlist if you do not own it yet.'
          : 'UPC lookup searches all systems.',
        empty: 'No catalog matches found for that UPC.',
        mode: 'upc',
      });
      this.addView = 'home';
      this.renderApp();
      this.setStatus('');
    }

    async fetchCatalogItems({ query = '', system = '', limit = 360 } = {}) {
      const params = new URLSearchParams();
      if (query) params.set('q', query);
      if (system) params.set('system', system);
      params.set('limit', String(limit));
      const result = await this.request(`/api/catalog?${params.toString()}`);
      return {
        ...result,
        items: Array.isArray(result.items) ? result.items : [],
      };
    }

    setCatalogResults(items, { title = '', help = '', empty = '', mode = 'catalog', systems = null, consoleOnly = false } = {}) {
      let results = this.filterCatalogItems(items);
      if (systems) {
        results = this.filterItemsToSystems(results, systems);
      }
      if (consoleOnly) {
        results = results.filter(isConsoleCatalogItem);
      }

      this.catalogResults = this.uniqueCatalogItems(results);
      this.catalogResultsTitle = title;
      this.catalogResultsHelp = help;
      this.catalogResultsEmpty = empty;
      this.catalogResultsMode = mode;
    }

    filterItemsToSystems(items, systems) {
      const allowedSystems = normalizedSystemSet(systems);
      if (!allowedSystems.size) return items;
      return (Array.isArray(items) ? items : []).filter((item) => allowedSystems.has(normalizeCatalogSystem(catalogSystemForItem(item))));
    }

    uniqueCatalogItems(items) {
      const seen = new Set();
      return (Array.isArray(items) ? items : []).filter((item) => {
        const key = this.catalogResultKey(item);
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    }

    catalogResultKey(item) {
      const priceChartingId = String(item?.priceChartingId || '').trim();
      if (priceChartingId) return `pc:${priceChartingId}`;

      return [
        'exact',
        normalizeCatalogSystem(catalogTitle(item)),
        normalizeCatalogSystem(catalogSystemForItem(item)),
        normalizeCatalogSystem(item?.consoleVariation || item?.variation || item?.model || item?.color || ''),
      ].join(':');
    }

    catalogSystemForSearch(value) {
      const system = String(value || '').trim();
      const normalized = system.toLowerCase().replace(/[^a-z0-9]+/g, '');
      const aliases = {
        all: '',
        any: '',
        gb: 'GameBoy',
        gameboy: 'GameBoy',
        gba: 'GameBoy Advance',
        gbc: 'GameBoy Color',
        gameboyadvance: 'GameBoy Advance',
        gameboycolor: 'GameBoy Color',
        gamecube: 'Gamecube',
        n64: 'Nintendo 64',
        nintendo64: 'Nintendo 64',
        switch: 'Nintendo Switch',
        nintendoswitch: 'Nintendo Switch',
        switch2: 'Nintendo Switch 2',
        nintendoswitch2: 'Nintendo Switch 2',
        nes: 'NES',
        snes: 'Super Nintendo',
        supernintendo: 'Super Nintendo',
        ps1: 'Playstation',
        ps2: 'Playstation 2',
        ps3: 'Playstation 3',
        ps4: 'Playstation 4',
        ps5: 'Playstation 5',
        psp: 'PSP',
        vita: 'Playstation Vita',
        playstationvita: 'Playstation Vita',
        xbox360: 'Xbox 360',
        xboxone: 'Xbox One',
        xboxseries: 'Xbox Series X',
        xboxseriesx: 'Xbox Series X',
        xboxseriesxs: 'Xbox Series X',
        dreamcast: 'Sega Dreamcast',
        saturn: 'Sega Saturn',
        segasaturn: 'Sega Saturn',
        segadreamcast: 'Sega Dreamcast',
        genesis: 'Sega Genesis',
        segagenesis: 'Sega Genesis',
        mastersystem: 'Sega Master System',
        segamastersystem: 'Sega Master System',
        segacd: 'Sega CD',
        sega32x: 'Sega 32X',
        gamegear: 'Sega Game Gear',
        segagamegear: 'Sega Game Gear',
        pcengine: 'PC Engine',
        pcenginecd: 'PC Engine CD'
      };

      return aliases[normalized] ?? system;
    }

    catalogById(id) {
      return this.catalogResults.find((game) => this.catalogResultKey(game) === String(id));
    }

    consoleShortcutSystems() {
      const merged = [];
      const seen = new Set();
      const addSystem = (system) => {
        const label = systemLabel(system);
        const normalized = normalizeCatalogSystem(label);
        if (!normalized || seen.has(normalized)) return;
        if (!this.allowsCatalogSystem(label)) return;
        if (!systemCanHaveConsoleShortcut(label)) return;
        merged.push(label);
        seen.add(normalized);
      };

      this.filteredCatalogSystems(this.catalogSystems).forEach(addSystem);
      FALLBACK_CONSOLE_VARIANTS.forEach((variant) => addSystem(variant.system));
      return merged;
    }

    async catalogItemForCollectionItem(item) {
      const lookupIds = [
        item?.priceChartingId,
        item?.catalogId,
        String(item?.id || '').startsWith('pcid_') ? item.id : '',
      ]
        .map((value) => String(value || '').trim())
        .filter(Boolean);

      for (const lookupId of [...new Set(lookupIds)]) {
        try {
          const result = await this.request(`/api/catalog/${encodeURIComponent(lookupId)}`);
          if (result.item) return result.item;
        } catch (_) {
          // Keep trying other identifiers or the title/system fallback below.
        }
      }

      return this.catalogItemByTitleAndSystem(item);
    }

    toggleManualAdd() {
      this.manualAddOpen = !this.manualAddOpen;
      this.renderApp();
    }

    async catalogItemByTitleAndSystem(item) {
      const title = String(item?.title || item?.name || '').trim();
      const system = String(catalogSystemForItem(item)).trim();
      if (!title) return null;

      const params = new URLSearchParams();
      params.set('q', title);
      if (system) params.set('system', system);
      params.set('limit', '12');

      const result = await this.request(`/api/catalog?${params.toString()}`);
      const items = Array.isArray(result.items) ? result.items : [];
      if (!items.length) return null;

      const targetTitle = normalizeCatalogSystem(title);
      const targetSystem = normalizeCatalogSystem(system);
      return items.find((candidate) => {
        const candidateTitle = normalizeCatalogSystem(candidate.title || candidate.name);
        const candidateSystem = normalizeCatalogSystem(catalogSystemForItem(candidate));
        return candidateTitle === targetTitle && (!targetSystem || candidateSystem === targetSystem);
      }) || null;
    }

    async updateEditValueForCondition(form, condition) {
      const id = form.dataset.id;
      const item = this.collection.find((entry) => String(entry.id) === String(id));
      const valueInput = form.querySelector('input[name="estimatedValue"]');
      if (!item || !valueInput) return;

      try {
        const catalogItem = await this.catalogItemForCollectionItem(item);
        if (!catalogItem) return;
        const nextValue = conditionValue(catalogItem, condition);
        if (nextValue > 0) valueInput.value = nextValue.toFixed(2);
      } catch (_) {
        // Some manually-added items do not have catalog IDs yet.
      }
    }

    async addCatalogForm(form, data) {
      const id = form.dataset.id;
      const game = this.catalogById(id);
      if (!game) throw new Error('Catalog item was not found.');
      const condition = String(data.get('condition') || this.defaultConditionForGame(game)).trim();
      if (condition === WISHLIST_CONDITION) {
        await this.wishlistCatalog(id);
        return;
      }
      await this.request('/api/collection', {
        method: 'POST',
        body: JSON.stringify({
          item: {
            catalogId: game.id,
            priceChartingId: game.priceChartingId,
            upc: game.upc,
            title: game.title || game.name,
            consoleName: catalogSystemForItem(game),
            condition,
            quantity: Number.parseInt(data.get('quantity') || 1, 10) || 1,
            imageUrl: game.imageUrl,
            itemType: catalogItemType(game),
            estimatedValue: Number(data.get('estimatedValue') || conditionValue(game, condition) || 0),
            notes: String(data.get('notes') || '').trim(),
          },
        }),
      });
      this.activeTab = 'collection';
      await this.loadAll();
      this.setStatus('Item added to your collection.');
    }

    async wishlistCatalog(id) {
      const game = this.catalogById(id);
      if (!game) throw new Error('Catalog item was not found.');
      await this.request('/api/wishlist', {
        method: 'POST',
        body: JSON.stringify({
          item: {
            catalogId: game.id,
            priceChartingId: game.priceChartingId,
            upc: game.upc,
            title: game.title || game.name,
            consoleName: catalogSystemForItem(game),
            desiredCondition: 'Any',
            notifyWhenInStock: true,
            imageUrl: game.imageUrl,
            itemType: catalogItemType(game),
          },
        }),
      });
      this.activeTab = 'wishlist';
      await this.loadAll();
      this.setStatus('Wishlist alert added.');
    }

    async manualAdd(data) {
      await this.request('/api/collection', {
        method: 'POST',
        body: JSON.stringify({
          item: {
            title: String(data.get('title') || '').trim(),
            consoleName: String(data.get('consoleName') || '').trim(),
            condition: String(data.get('condition') || 'Game only').trim(),
            estimatedValue: Number(data.get('estimatedValue') || 0),
            quantity: Number.parseInt(data.get('quantity') || 1, 10) || 1,
            upc: String(data.get('upc') || '').trim(),
            priceChartingId: String(data.get('priceChartingId') || '').trim(),
            notes: String(data.get('notes') || '').trim(),
          },
        }),
      });
      this.activeTab = 'collection';
      await this.loadAll();
      this.setStatus('Manual item added.');
    }

    editItem(id) {
      this.editingItemId = String(id || '');
      this.renderApp();
    }

    cancelEdit() {
      this.editingItemId = '';
      this.renderApp();
    }

    async saveItem(form, data) {
      const id = form.dataset.id;
      const item = this.collection.find((entry) => String(entry.id) === String(id));
      if (!item) throw new Error('Collection item was not found.');

      await this.request(`/api/collection/${encodeURIComponent(id)}`, {
        method: 'PUT',
        body: JSON.stringify({
          item: {
            ...item,
            condition: String(data.get('condition') || item.condition || 'Game only').trim(),
            quantity: Number.parseInt(data.get('quantity') || item.quantity || 1, 10) || 1,
            estimatedValue: Number(data.get('estimatedValue') || 0),
            consoleName: String(data.get('consoleName') || item.consoleName || '').trim(),
            notes: String(data.get('notes') || '').trim(),
          },
        }),
      });
      this.editingItemId = '';
      await this.loadAll();
      this.setStatus('Item updated.');
    }

    async wishlistManual(data) {
      await this.request('/api/wishlist', {
        method: 'POST',
        body: JSON.stringify({
          item: {
            title: String(data.get('title') || '').trim(),
            consoleName: String(data.get('consoleName') || '').trim(),
            desiredCondition: String(data.get('desiredCondition') || 'Any').trim(),
            targetPrice: Number(data.get('targetPrice') || 0) || null,
            notifyWhenInStock: true,
          },
        }),
      });
      await this.loadAll();
      this.activeTab = 'wishlist';
      this.renderApp();
      this.setStatus('Wishlist alert added.');
    }

    async sellSubmit(form, data) {
      const selectedItemIds = Array.from(form.querySelectorAll('input[name="selectedItemIds"]:checked'))
        .map((input) => input.value);
      if (!selectedItemIds.length) throw new Error('Select at least one item.');
      await this.request('/api/collection/sell-submissions', {
        method: 'POST',
        body: JSON.stringify({
          selectedItemIds,
          tradeMethod: String(data.get('tradeMethod') || 'bring_in'),
          note: String(data.get('note') || '').trim(),
          termsAccepted: data.get('termsAccepted') === 'on',
        }),
      });
      this.activeTab = 'collection';
      await this.loadAll();
      this.setStatus('Sell/trade review submitted.');
    }

    async deleteItem(id) {
      if (!window.confirm('Remove this item from your collection?')) return;
      await this.request(`/api/collection/${encodeURIComponent(id)}`, { method: 'DELETE' });
      await this.loadAll();
      this.setStatus('Item removed.');
    }

    async markSold(id, soldTo = null) {
      const item = this.collection.find((entry) => String(entry.id) === String(id));
      if (!item) return;
      await this.request(`/api/collection/${encodeURIComponent(id)}`, {
        method: 'PUT',
        body: JSON.stringify({
          item: {
            ...item,
            soldTo: soldTo || item.soldTo,
            soldAt: new Date().toISOString(),
          },
        }),
      });
      await this.loadAll();
      this.setStatus('Item marked sold.');
    }

    async unsubmitItem(id) {
      const item = this.collection.find((entry) => String(entry.id) === String(id));
      if (!item) return;
      await this.request(`/api/collection/${encodeURIComponent(id)}`, {
        method: 'PUT',
        body: JSON.stringify({
          item: {
            ...item,
            saleSubmissionId: null,
            saleSubmittedAt: null,
            saleSubmittedQuantity: null,
          },
        }),
      });
      await this.loadAll();
      this.setStatus('Item kept in your collection.');
    }

    async deleteWishlist(id) {
      await this.request(`/api/wishlist/${encodeURIComponent(id)}`, { method: 'DELETE' });
      await this.loadAll();
      this.activeTab = 'wishlist';
      this.renderApp();
      this.setStatus('Wishlist item removed.');
    }

    async logout(showMessage = true) {
      this.token = '';
      this.collection = [];
      this.wishlist = [];
      localStorage.removeItem(TOKEN_KEY);
      await fetch(`${this.endpoint}/api/auth/logout`, {
        method: 'POST',
        credentials: 'include',
      }).catch(() => {});
      this.renderAuth();
      if (showMessage) this.setStatus('Logged out.');
    }
  }

  if (!customElements.get('cavern-collection-app')) {
    customElements.define('cavern-collection-app', CavernCollectionApp);
  }
})();
